const API_URL = "https://console-shopify.ringbuilder.io/frontend.php";
const STONE_TYPES = ["labgrown", "natural"];
let vdbrcSettingProductGroupId = "";
let isStoneSelected = false;
var vdbrcCaratSizeSelectedValue = "";

var vdbrcShapeImages = {
    "Round": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shape_Round_56b2ba1f-740f-4505-a0bd-41e9985d08ca.png?v=1779737174",
    "Oval": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shape_Oval_5ed46e08-be2a-4306-a7c5-43063ddbb3f5.png?v=1779737173",
    "Pear": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shape_Pear_5fbaf9bb-3341-47ea-b43d-ddcaba1584ff.png?v=1779737173",
    "Square Cushion": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shape_Sq._Cushion.png?v=1779737174",
    "Cushion": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shape_Long_Cushion.png?v=1779737174",
    "Long Cushion": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shape_Long_Cushion.png?v=1779737174",
    "Emerald": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shape_Emerald_68f0cacf-1c2d-48ca-9584-c0cfb65c4e4e.png?v=1779737174",
    "Princess": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shape_Princess_faa916d4-7203-430e-bbcf-98700ecfbbc2.png?v=1779737173",
    "Marquise": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shape_Marquise_936a8a9d-51d4-47e5-942e-101109dedc78.png?v=1779737174",
    "Radiant": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shape_Radiant_a253d47c-c678-44d9-93df-0b1d9ae50204.png?v=1779737173",
    "Asscher": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shape_Asscher_a8654248-1af0-40b4-9dd1-10cd34490f34.png?v=1779737175",
    "Heart": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shape_Heart_96cea6f7-aad0-490e-90ca-93c4984efdb5.png?v=1779737174"
};
var vdbrcHeadStyleImages = {
    "Classic Basket": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heads_Classic_Basket.png?v=1779737175",
    "Classic Bezel": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heads_Classic_Bezel.png?v=1779737174",
    "Diamond Tulip": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heads_Diamond_Tulip.png?v=1779737175",
    "Dual Halo": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heads_Dual_Halo.png?v=1779737175",
    "Fancy Halo": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heads_Fancy_Halo.png?v=1779737175",
    "Four Prong": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heads_Four_Prongs.png?v=1779737175",
    "Hidden Halo": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heads_Hidden_Halo.png?v=1779737174",
    "Lotus Basket": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heads_Lotus_Basket.png?v=1779737175",
    "Scallopes Six Prongs": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heads_Scalloped_Six_Prongs.png?v=1779737175",
    "Six Prong": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heads_Six_Prongs.png?v=1779737175",
    "Six Prong diamond": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heads_Six_Prong_Diamond.png?v=1779737175",
    "Surprise diamond": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heads_Surprise_Diamond.png?v=1779737175",
    "Tulip Basket": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heads_Tulip_Basket.png?v=1779737175",
    "Vintage Basket": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heads_Vintage_Basket.png?v=1779737173",
    "Diamond Basket BN": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heads_Diamond_Basket_BN.png?v=1779737174",
    "Classic Halo": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heads_Classic_Halo.png?v=1779737175",
    "Pave Basket": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heads_Pave_Basket.png?v=1779821607",
    "Pave Halo": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heads_Pave_Halo.png?v=1779821607"
};
var vdbrcShankStyleImages = {
    "Alternating Marquise": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shanks_Alternating_Marquise.png?v=1779737175",
    "Baguette Channel": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shanks_Baguette_Channel.png?v=1779737175",
    "Cathedral Pave": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shanks_Cathedral_Pave.png?v=1779737175",
    "Channel": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shanks_Channel_Set.png?v=1779737175",
    "Floating Station": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shanks_Floating_Station.png?v=1779737175",
    "French Pave": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shanks_French_Pave.png?v=1779737175",
    "Knife Edge Pave": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shanks_Knife_Edge_Pave.png?v=1779737175",
    "Knife Edge Solitaire": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shanks_Knife_Edge_Solitiare_Real.png?v=1779821607",
    "Knife Edge Cathedral": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shanks_Knife_Edge_Solitiare.png?v=1779737173",
    "Rope Pave": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shanks_Rope_Pave.png?v=1779737175",
    "Sleek Accent": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shanks_Sleek_Accent.png?v=1779737175",
    "Solitaire": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shanks_Solitiare.png?v=1779737175",
    "Split Ring Solitaire": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shanks_Split_Ring_Solitiare.png?v=1779737175",
    "Triple Row Pave": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shanks_Triple_Row_Pave.png?v=1779737174",
    "Twist Pave": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shanks_Twist_Pave.png?v=1779737174",
    "Alternating Baguette": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shanks_Alternating_Baguette.png?v=1779737175",
    "Rope Solitiare": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shanks_Rope_Solitiare.png?v=1779737174"
};
var vdbrcColorImages = {
    "White Gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Metal_Color_6bca3560-297a-4ee2-aa8d-305a11939dd0.svg?v=1773290630",
    "Yellow Gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Metal_Color_8314132c-681d-4ed4-bab7-2ec5b3698a75.svg?v=1774241440",
    "Rose Gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Rose_Metal.svg?v=1775493980",
    "W+Y Gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Metal_Color_a0a6f212-86e0-4d0f-97c6-e2bce6b58e4b.svg?v=1774241450",
    "W+R Gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Metal_Color_87c4d621-f553-44ed-a71b-6260f49abe85.svg?v=1767348988",
    "White/Yellow Gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Metal_Color_a0a6f212-86e0-4d0f-97c6-e2bce6b58e4b.svg?v=1774241450",
    "White/Rose Gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Metal_Color_87c4d621-f553-44ed-a71b-6260f49abe85.svg?v=1767348988",
    "Two Tone Yellow Gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Metal_Color_a0a6f212-86e0-4d0f-97c6-e2bce6b58e4b.svg?v=1774241450",
    "Two Tone Rose Gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Metal_Color_87c4d621-f553-44ed-a71b-6260f49abe85.svg?v=1767348988",
};
var vdbrcDiamondColorImages = {
    "White": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/icon-white.png",
    "Yellow": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/icon-Yellow.png",
    "Pink": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/icon-Pink.png",
    "Green": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/icon-Green.png",
    "Blue": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/icon-Blue.png",
    "Orange": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/icon-Orange.png",
    "Brown": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/icon-Brown.png",
    "Black": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/32773ab1c0a98b8a7934ca157961f32b4265fef4_bc218fa1-c2ed-46ee-a7c8-fd69d4f7dc04.png?v=1774374844",
    "Other": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/icon-Other.png"
};
var engravingOptionImages = {
    "White Gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/white-engrave.png",
    "Yellow Gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/yellow-engrave.png",
    "Rose Gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/red-engrave.png",
    "W+Y Gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/yellow-engrave.png",
    "W+R Gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/red-engrave.png",
    "White/Yellow Gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/yellow-engrave.png",
    "White/Rose Gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/red-engrave.png",
    "Two Tone Yellow Gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/yellow-engrave.png",
    "Two Tone Rose Gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/red-engrave.png",
};

const canvasId = 'webgl_vdb_canvas';
const three_d_static_data = [
    {
        "pmat": {
            "yellow_gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/antique-yellow.pmat",
            "white_gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/antique-white.pmat",
            "rose_gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/antique-rose.pmat"
        },
        "dmat": {
            "default":"https://cdn.shopify.com/s/files/1/0755/7854/0322/files/antique-threed-dmat.dmat",
            "round":"https://cdn.shopify.com/s/files/1/0755/7854/0322/files/mainestone-round.dmat?v=1791288241",
            "oval":"https://cdn.shopify.com/s/files/1/0755/7854/0322/files/mainestone-oval.dmat?v=1791288264",
            "pear":"https://cdn.shopify.com/s/files/1/0755/7854/0322/files/mainstone-pear.dmat?v=1791288275",
            "e cushion":"https://cdn.shopify.com/s/files/1/0755/7854/0322/files/mainstone-sq-cushion.dmat?v=1791288327",
            "cushion":"https://cdn.shopify.com/s/files/1/0755/7854/0322/files/mainstone-cushion.dmat?v=1791288295",
            "emerald":"https://cdn.shopify.com/s/files/1/0755/7854/0322/files/mainstone-emerald.dmat?v=1791288341",
            "princess":"https://cdn.shopify.com/s/files/1/0755/7854/0322/files/mainstone-princess.dmat?v=1791288351",
            "marquise":"https://cdn.shopify.com/s/files/1/0755/7854/0322/files/mainstone-Marquise.dmat?v=1791288478",
            "radiant":"https://cdn.shopify.com/s/files/1/0755/7854/0322/files/mainstone-RADIANT.dmat?v=1791288542",
            "asscher":"https://cdn.shopify.com/s/files/1/0755/7854/0322/files/mainstone-asscher.dmat?v=1791288550",
            "long cushion":"https://cdn.shopify.com/s/files/1/0755/7854/0322/files/mainstone-long-cushion.dmat?v=1791288564",
            "heart":"https://cdn.shopify.com/s/files/1/0755/7854/0322/files/mainstone-heart.dmat?v=1791288578",
            "square cushion":"https://cdn.shopify.com/s/files/1/0755/7854/0322/files/mainstone-sq-cushion.dmat?v=1791288327"
        },
        "vjson": "https://all-demos.s3.us-east-1.amazonaws.com/3D_Assets/Antique-Cut/CADs/Antique-Imagesss.vjson",//https://cdn.shopify.com/s/files/1/0755/7854/0322/files/antique-threed-vjson.vjson
    }
];

const vdbrcLoaderFallback = setTimeout(function () {
    // Avoid trapping the shopper if an unexpected third-party/API failure
    // prevents initialization from reaching its normal completion path.
    $('main').removeClass('is-loading');
}, 15000);

const vdbrcSettingInfoCache = new Map();
const vdbrcSubOptionsCache = new Map();
let vdbrcThreeDInitialized = false;
let vdbrcPendingThreeD = null;

function vdbrcRevealSettingPage() {
    clearTimeout(vdbrcLoaderFallback);
    $('main').removeClass('is-loading');
}

function vdbrcScheduleThreeDInit(headGlb, shankGlb) {
    vdbrcPendingThreeD = { headGlb: headGlb, shankGlb: shankGlb };
    const trackThreeD = !!(window.player && typeof window.player.beginThreeDLoad === "function");
    if (trackThreeD) window.player.beginThreeDLoad();
    const run = async function () {
        let reveal = false;
        try {
            if (!vdbrcPendingThreeD || vdbrcThreeDInitialized) return;
            const pending = vdbrcPendingThreeD;
            reveal = await handleThreeDPart(pending.headGlb, pending.shankGlb, false) !== false;
        } finally {
            if (trackThreeD) window.player.endThreeDLoad(reveal);
        }
    };
    if (typeof requestIdleCallback === 'function') {
        requestIdleCallback(run, { timeout: 2000 });
    } else {
        setTimeout(run, 1);
    }
}

$(document).ready(async function () {
    const params = new URLSearchParams(window.location.search);
    isStoneSelected =
        (params.has('labgrown_stock_num') && params.get('labgrown_stock_num').trim() !== '') ||
        (params.has('natural_stock_num') && params.get('natural_stock_num').trim() !== '');

    if (isStoneSelected) {
        $('.vdbrc_complete_my_ring_btn').removeClass('d-none');
        $('.vdbrc_complete_my_ring_btn').text('Select Setting');
        $('.vdbrc_add_to_cart_btn').hide();

        const stockNumParam = params.get('natural_stock_num') ? 'natural_stock_num' : 'labgrown_stock_num';
        const stockNum = params.get(stockNumParam);

        if (stockNum && stockNum !== '') {
            const response = await get_stone_info(stockNum, stockNumParam);

            if (response && response.success === true && response.data) {
                const stone = response.data;

                const stock_num = stone["stock_num"];
                const stock_id = stone["id"];
                const shape = formatValue(stone["shape"]);
                const size = formatSize(stone["size"]);
                const clarity = formatValue(stone["clarity"]);
                const cut = formatValue(stone["cut"],'-');
                const color = formatValue(stone["color"]);
                const polish = formatValue(stone["polish"]);
                const image_url = vdbrcResolveStoneImageUrl(formatValue(stone["image_url"], no_image_url), no_image_url);
                const video_url = formatValue(stone["video_url"]);
                const video_type = formatValue(stone["video_type"]);
                const cert_url = formatValue(stone["cert_url"]);
                const cert_num = formatValue(stone["cert_num"]);
                const long_title = formatValue(stone["long_title"]);
                const comments = formatValue(stone["comments"]);
                const lab = formatValue(stone["lab"]);
                const stone_currency_code = stone["currency_code"] ? stone["currency_code"] : "USD";
                const total_sales_price = stone["total_sales_price"];
                const vendor_id = formatValue(stone["vendor_id"]);
                const vendor_name = formatValue(stone["vendor_name"]);

                const price = handlePriceData(stone_currency_code, total_sales_price);
                const price_without_format = handlePriceData(stone_currency_code, total_sales_price, true);

                console.log('total_sales_price',total_sales_price);
                console.log('stone_currency_code',stone_currency_code);
                console.log('price',price);
                console.log('price_without_format',price_without_format);

                const name = long_title || `${shape} ${size} ${color} ${clarity}`;
                const displayName = `${size} carat ${shape} <span>${color} ${clarity} Lab</span>`;

                const measurements_arr = [
                    formatValue(stone["meas_length"], "0.00"), formatValue(stone["meas_width"], "0.00"),
                ];
                const measurements = measurements_arr.every((element) => element === "0.00") ? "-" : measurements_arr.join(" x ");

                const stoneOrigin = stockNumParam === 'labgrown_stock_num' ? "Lab Grown" : "Natural";

                let videoHtml = "";
                if (video_type == 'native') {
                    videoHtml = `<video class="vdb_stone_video" src="" controls controlsList="nodownload" data-src="${video_url}" style="display: none"></video>'`;
                } else {
                    videoHtml = `<iframe class="vdb_stone_video" allow="autoplay" src="" frameborder="0" data-src="${video_url}" style="display: none"></iframe>`;
                }

                vdbrcSetStoneButtonData({
                    'data-stone-stock-num': stock_num,
                    'data-stone-stock-id': stock_id,
                    'data-stone-price': price_without_format,
                    'data-stone-image': image_url,
                    'data-stone-title': `${size} carat ${shape} ${color} ${clarity} Lab`,
                    'data-stone-shape': shape,
                    'data-stone-carat': size,
                    'data-stone-color': color,
                    'data-stone-clarity': clarity,
                    'data-stone-cut': cut,
                    'data-stone-polish': polish,
                    'data-stone-lab': lab,
                    'data-stone-certificate': cert_num,
                    'data-stone-origin': stoneOrigin,
                    'data-vendor-id': vendor_id,
                    'data-vendor-name': vendor_name
                });

                $(".vdbrc_product_image").attr('src', image_url);
                $('.vdbrc_product_thumbnail_btn').attr('data-image', image_url);
                $('.vdbrc_product_thumbnail_btn').attr('data-video', video_url);

                $(".vdbrc_thumbnail_container").append(videoHtml);

                $(".vdbrc_stone_title").html(`${size} carat ${shape} ${color} ${clarity} Lab`);
                $(".vdbrc_stone_price").html(price);
                $(".vdbrc_stone_image").attr('src', image_url);

                $(".vdbrc_subtotal_price").attr('data-stone-price', price_without_format);

                $("#vdbrc_stepper .aqcstone-progress-price[data-stone-product-price]").text(price);

                $(".vdbrc_stone_carat").text(size);
                $(".vdbrc_stone_color").text(color);
                $(".vdbrc_stone_clarity").text(clarity);
                $(".vdbrc_stone_cut").text(cut);
                $(".vdbrc_stone_dimensions").text(measurements);
                $(".vdbrc_stone_certificat_lab").text(lab);
                if (window.vdbrcSyncLabCertificate) {
                    window.vdbrcSyncLabCertificate(lab, cert_url);
                } else if (window.vdbrcApplyLabCertImage) {
                    window.vdbrcApplyLabCertImage(lab);
                    $('.vdbrc_stone_certificat_url').data('url', cert_url);
                    $('.vdbrc_stone_certificat_container').toggle(!!cert_url);
                }
                $(".vdbrc_stone_description").text(comments);

                $(".vdbrc_stone_meas_ratio").text(formatValue(stone["meas_ratio"], "0.00") === "0.00" ? "-" : formatValue(stone["meas_ratio"], "0.00"));
            }
        }
    } else {
        $('.vdbrc_complete_my_ring_btn').removeClass('d-none');
        $('.vdbrc_complete_my_ring_btn').text('Select Setting');
    }

    if (params.has('review') && params.get('review') == 'true') {
        $('#vdbrc_review_summary').show();
        $('#vdbrc_setting_pdp_info').hide();

        let viewSettingUrl = $("#vdbrc_stepper .vdbrc_setting_step .step-link.view_link").attr('href') || '';
        let changeSettingUrl = $("#vdbrc_stepper .vdbrc_setting_step .step-link.change_link").attr('href') || '';
        let viewStoneUrl = $("#vdbrc_stepper .vdbrc_diamond_step .step-link.view_link").attr('href') || '';
        let changeStoneUrl = $("#vdbrc_stepper .vdbrc_diamond_step .step-link.change_link").attr('href') || '';
        $("a.vdbrc_view_setting_product").attr('href', viewSettingUrl);
        $("a.vdbrc_change_setting_product").attr('href', changeSettingUrl);
        $("a.vdbrc_view_stone_product").attr('href', viewStoneUrl);
        $("a.vdbrc_change_stone_product").attr('href', changeStoneUrl);

        $("div[data-media-display-review-page='yes']").show();
        $("div[data-media-display-review-page='no']").hide();
    } else {
        $('#vdbrc_review_summary').hide();
        $('#vdbrc_setting_pdp_info').show();

        $("div[data-media-display-setting-page='yes']").show();
        $("div[data-media-display-setting-page='no']").hide();
    }

    const engravingText = getCookie('vdbrc_setting_engraving_text') || "";
    const engravingFont = getCookie('vdbrc_setting_engraving_font') || "";

    if(engravingText || engravingFont){
        $(".vdbrc_final_engraving").val(engravingText);
        $('.vdbrc_engaving_details').data('engraving-text', engravingText).data('engraving-font', engravingFont);
    }
    
    const ringSize = getCookie('vdbrc_setting_ring_size') || "";
    if (ringSize !== "") {
        const option = $(`.spdp-ring-size-option[data-value="${ringSize}"]`);

        if (option.length) {
            // Remove previous selection
            $('.spdp-ring-size-option').removeClass('selected');

            // Set new selection
            option.addClass('selected');

            // Trigger click (important if logic is bound to click)
            option.trigger('click');
        }
    }
    await bindSettingData();
    // Reveal as soon as product data is bound — don't wait for window.load / WebGL
    vdbrcRevealSettingPage();

    if(isMobileDevice()){
        $("div[data-media-display-device-type='web']").hide();
        $("div[data-media-display-device-type='mobile']").show();
    }
});

async function bindSettingData() {
    if (typeof productHandle === 'undefined' || !productHandle) return;

    try {
        var response = await get_setting_info(productHandle);

        if (!response || response.status !== 'success' || !response.data || !response.data.option_data) {
            return;
        }

        // If group id is available in response and not set in Liquid:
        if (!vdbrcSettingProductGroupId && response.group_id) {
            vdbrcSettingProductGroupId = response.group_id;
        }
        let optionData = response.data.option_data;

        renderAllOptionsFromResponse(optionData);

        let product_data = response.data.product_data;
        if (product_data) {
            $('.vdbrc_setting_prod_title').text(product_data.prod_title || '');

            const price_without_format = vdbrcApplySettingPrice(product_data);
            $('.vdbrc_add_to_cart_btn').attr('data-variant-id', product_data.variant_id || '');
            $('.vdbrc_final_add_to_cart').attr('data-variant-id', product_data.variant_id || '');
            $(".vdbrc_subtotal_price").attr('data-setting-price', price_without_format);

            let stonePrice = $(".vdbrc_subtotal_price").attr('data-stone-price') || 0;
            let settingPrice = $(".vdbrc_subtotal_price").attr('data-setting-price') || 0;
            let subtotalPrice = vdbrcFormatMoney((Number(stonePrice) + Number(settingPrice)) * 100, market_currency_symbol + " {amount}");
            $(".vdbrc_subtotal_price").html(subtotalPrice);

            const images = (product_data?.images && product_data.images != "") ? (product_data.images).split(",") : [];
            if (images.length > 0) {
                $(".vdbrc_setting_image").attr('src', images[0]).show();
                $(".vdbrc_thumb_image_btn").attr('data-image', images[0]);

                const $track = $(".vdbrc_gallery_slider");     // your slider track container
                $track.empty();

                let sliderImageArray = [];
                if(isMobileDevice()) {
                    sliderImageArray = images.slice(0, 11); // We will display 1-10 index images in slider
                }else{
                    sliderImageArray = images.slice(1, 11); // We will display 1-10 index images in slider
                }

                if (sliderImageArray.length > 0) {
                    // build slides dynamically
                    sliderImageArray.forEach(function (url, i) {
                        url = (url || "").trim();
                        if (!url) return;

                        $track.append(`
                                <div class="slide ${i === 0 ? "active" : ""}">
                                    <img src="${url}" alt="Ring ${i + 1}" class="stonepdp-gallery-image">
                                </div>
                            `);
                    });

                    initSimpleSlider(".simple-slider");
                    initSimpleSlider(".simple-slider-mobile");
                } else {
                    $(".vdbrc_gallery_slider_container").hide();
                }

                if (images[2] && images[2].trim() != "") {
                    $(".vdbrc_setting_ring_on_hand_image").attr('src', images[2]).show();
                } else {
                    $(".vdbrc_setting_ring_on_hand_image_container").hide();
                }

                if (images[11] && images[11].trim() != "") {
                    $(".vdbrd_setting_hand_view_image").attr('src', images[11]).show();
                } else {
                    $(".vdbrc_setting_hand_view_container").hide();
                }
            } else {
                $(".vdbrc_thumb_image_btn").hide();
            }

            const video_url = product_data?.videos || '';
            if (video_url) {
                $(".vdbrc_setting_video").attr('src', video_url).show();
                $(".vdbrc_thumb_video_btn").attr('data-video', video_url);
            } else {
                $(".vdbrc_setting_video_container").hide();
                $(".vdbrc_thumb_video_btn").hide();
            }

            const caratGlbMap = {};
            if (product_data?.carat_glbs && product_data.carat_glbs != "") {
                const glbArray = product_data.carat_glbs.split(",");

                glbArray.forEach(item => {
                    const parts = item.split("|");

                    if (parts.length === 3) {
                        let caratStr = parts[0].replace("CT", "").trim(); // "1.00CT" → "1.00"
                        let carat = parseFloat(caratStr);

                        caratGlbMap[carat] = {
                            head_glb: parts[1],
                            shank_glb: parts[2]
                        };
                    }
                });
            }

            const caratArray = (product_data?.carat_images && product_data.carat_images != "") ? (product_data.carat_images).split(",") : [];
            if (caratArray.length > 0) {
                $('.vdbrc_setting_pdp_option[data-type="Carat Size"]').show();

                let formattedCaratData = $.map(caratArray, function (item) {
                    const firstColonIndex = item.indexOf(":");
                    const caratValue = item.substring(0, firstColonIndex);
                    const imageURL = item.substring(firstColonIndex + 1);
                    return {
                        carat: parseFloat(caratValue),
                        image: imageURL
                    };
                });

                formattedCaratData.sort(function (a, b) {
                    return a.carat - b.carat;
                });

                const container = $("#vdbrc_carat_options_container");
                container.empty();

                $.each(formattedCaratData, function (index, item) {
                    const glbData = caratGlbMap[item.carat] || {};

                    const div = $("<div>", {
                        class: "spdp-carat-option",
                        text: item.carat,
                        "data-image": item.image,
                        "data-carat": item.carat,
                        "data-head-glb": glbData.head_glb || "",
                        "data-shank-glb": glbData.shank_glb || ""
                    });

                    container.append(div);
                });

                container.find(".spdp-carat-option").first().trigger("click");
            }else{
                $('.vdbrc_setting_pdp_option[data-type="Carat Size"]').hide();
            }

            const metaFieldJson = product_data?.metafield_json ? JSON.parse(product_data.metafield_json) : null;

            if (metaFieldJson && Array.isArray(metaFieldJson)) {
                function getValue(key) {
                    const item = metaFieldJson.find(obj => obj.key === key);
                    return item && item.value ? item.value : "-";
                }
                $(".vdbrc_setting_prod_height").text(getValue("VDB Ring Height"));
                $(".vdbrc_setting_prod_width").text(getValue("VDB Ring Width"));
                $(".vdbrc_setting_prod_carat").text(getValue("VDB Ring Avg Total Carat"));
                $(".vdbrc_setting_prod_color").text(getValue("VDB Ring Avg Color"));
                $(".vdbrc_setting_prod_clarity").text(getValue("VDB Ring Avg Clarity"));
                $(".vdbrc_setting_prod_finish").text(getValue("VDB Ring Rhodium Finish"));
                $(".vdbrc_setting_prod_quantity").text(getValue("VDB Ring Quantity"));
                $(".vdbrc_setting_prod_measurement").text(getValue("VDB Ring Measurement"));
            }

            // Get first key
            const firstKeyOfCaratGlbMap = Object.keys(caratGlbMap)[0];
            const { head_glb, shank_glb } = caratGlbMap[firstKeyOfCaratGlbMap];

            if(head_glb && shank_glb && head_glb !== "" && shank_glb !== "") {
                vdbrcScheduleThreeDInit(product_data.head_glb, product_data.shank_glb);
            } else if (product_data?.head_glb && product_data?.shank_glb && product_data?.head_glb !== "" && product_data?.shank_glb !== "") {
                vdbrcScheduleThreeDInit(product_data.head_glb, product_data.shank_glb);
            } else {
                $(".vdbrc_thumb_3d_btn").hide();
            }
        }

        if (optionData.length > 0) {
            var shankStyle = $.grep(optionData, function (item) {
                return item.label === "Shank Style";
            })[0].selected;


            var headStyle = $.grep(optionData, function (item) {
                return item.label === "Head Style";
            })[0].selected;

            var metal = $.grep(optionData, function (item) {
                return item.label === "Metal";
            })[0].selected;

            var color = $.grep(optionData, function (item) {
                return item.label === "Color";
            })[0].selected;

            var shankColor =  "";
            var headColor =  "";
            if(metal && metal !== ""){
                if(metal.includes("Platinum")){
                    shankColor = "Platinum";
                    headColor = "Platinum";
                }else if(color && color !== "" && color.includes("Two Tone Yellow Gold")){
                    shankColor = metal + " " + "Yellow Gold";
                    headColor = metal + " " + "White Gold";
                }else if(color && color !== "" && color.includes("Two Tone Rose Gold")){
                    shankColor = metal + " " + "Rose Gold";
                    headColor = metal + " " + "White Gold";
                }else{
                    shankColor = metal + " " + color;
                    headColor = metal + " " + color;
                }
            }

            $(".vdbrc_setting_metal_type").text(shankColor);
            $(".vdbrc_setting_metal_type_2").text(headColor);
            $(".vdbrc_setting_shank_style").text(shankStyle);
            $(".vdbrc_setting_head_style").text(headStyle);
        }

    } catch (e) {
        console.error('Failed to load setting data', e);
    }
}

function vdbrcOptionSelectedMissing(selected) {
    if (selected == null) return true;
    var value = $.trim(String(selected));
    return value === '' || value.toLowerCase() === 'null';
}

function renderAllOptionsFromResponse(optionData) {
    renderShapeOptions(optionData);
    renderHeadStyleOptions(optionData);
    renderShankStyleOptions(optionData);
    renderMetalOptions(optionData);
    renderColorOptions(optionData);
    renderDiamondColorOptions(optionData);
    renderBandOptions(optionData);
}

function vdbrcRevealSelectedHiddenOption(container, hiddenClass, toggleClass) {
    var activeItem = container.find('.' + hiddenClass + '.active');
    if (!activeItem.length) return;

    var toggle = container.find('.' + toggleClass);
    container.find('.' + hiddenClass).show();
    toggle.find('.spdp-show-label').text('Show Less');
    toggle.find('.plus-icon').hide();
    toggle.find('.minus-icon').show();
}

function renderShapeOptions(optionData) {
    var wrapper = $('.vdbrc_setting_pdp_option[data-type="Shape"]');
    var container = $('#vdbrc_shape_options_container');

    if (!wrapper.length || !container.length) return;

    var filterOption = null;

    // Find Shape option
    $.each(optionData, function (i, option) {
        if (option.label === 'Shape') {
            filterOption = option;
            return false;
        }
    });

    if (!filterOption || !filterOption.values || !Object.keys(filterOption.values).length || vdbrcOptionSelectedMissing(filterOption.selected)) {
        wrapper.find('.vdbrc_selected_option_value').text('');
        wrapper.hide();
        container.hide();
        wrapper.addClass("d-none");
        return;
    }

    // If found → ensure visible
    wrapper.show();
    wrapper.removeClass("d-none");
    container.show();

    // Set selected value in header
    wrapper.find('.vdbrc_selected_option_value').text(`: ${filterOption.selected}`);
    wrapper.find('.vdbrc_tooltip_text').text(filterOption.description);

    var html = '';
    var index = 0;

    $.each(filterOption.values, function (id, label) {
        var isActive = (label === filterOption.selected);
        var imageUrl = vdbrcShapeImages[label] || Object.values(vdbrcShapeImages)[0];
        var hiddenClass = index >= 4 ? ' vdbrc_shape_hidden' : '';

        html += `
            <div class="spdp-shape-card vdbrc_shape_card${isActive ? ' active' : ''}${hiddenClass}"
                data-value-id="${id}"
                data-value-label="${label}"
                ${index >= 4 ? 'style="display: none;"' : ''}>
                ${imageUrl ? `<img src="${imageUrl}" alt="${label}">` : ''}
                <span class="spdp-shape-label">${label}</span>
            </div>
        `;

        index++;

        if (isActive) {
            $(".vdbrc_setting_prod_shape").text(label);
        }
    });

    /* Show More / Show Less toggle card */
    if (index > 4) {
        html += `
            <div class="spdp-shape-card vdbrc_shape_toggle">
                <div class="spdp-show-toggle">
                    <svg class="plus-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.0002 3.33331V16.6666M16.6668 9.99998H3.3335" stroke="#141B34" stroke-width="1.25" stroke-linejoin="round"></path>
                    </svg>
                    <svg class="minus-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: none;">
                        <path d="M16.6668 9.99998H3.3335" stroke="#141B34" stroke-width="1.25" stroke-linejoin="round"></path>
                    </svg>
                </div>
                <span class="spdp-show-label">Show More</span>
            </div>
        `;
    }

    container.html(html);
    vdbrcRevealSelectedHiddenOption(container, 'vdbrc_shape_hidden', 'vdbrc_shape_toggle');
}
$('body').on('click', '#vdbrc_shape_options_container .vdbrc_shape_card', async function () {
    var clicked = $(this);
    var label = clicked.data('value-label');

    $('#vdbrc_shape_options_container .vdbrc_shape_card').removeClass('active');
    clicked.addClass('active');

    $('.vdbrc_setting_pdp_option[data-type="Shape"] .vdbrc_selected_option_value').text(': ' + label);

    await vdbrcRefreshSubOptions();
});
$('body').on('click', '#vdbrc_shape_options_container .vdbrc_shape_toggle', function () {
    var container = $('#vdbrc_shape_options_container');
    var hiddenItems = container.find('.vdbrc_shape_hidden');
    var label = $(this).find('.spdp-show-label');
    var plusIcon = $(this).find('.plus-icon');
    var minusIcon = $(this).find('.minus-icon');

    if (hiddenItems.is(':visible')) {
        hiddenItems.hide();
        label.text('Show More');
        plusIcon.show();
        minusIcon.hide();
    } else {
        hiddenItems.show();
        label.text('Show Less');
        plusIcon.hide();
        minusIcon.show();
    }
});

$('body').on('click', '#vdbrc_carat_options_container .spdp-carat-option', async function (e) {
    const imageUrl = $(this).data("image");
    const caratValue = $(this).data("carat");
    const headGlb = $(this).data("head-glb");
    const shankGlb = $(this).data("shank-glb");

    $(".vdbrc_setting_carat_hand_image").attr("src", imageUrl);
    $(".spdp-carat-option").removeClass("active");

    $(".vdbrc_setting_carat_image_tag_text").text(`Shown in ${caratValue} Ct`);
    $('.vdbrc_setting_pdp_option[data-type="Carat Size"]')
        .find('.vdbrc_selected_option_value')
        .text(`: ${caratValue} Carat`);

    $(this).addClass("active");

    vdbrcCaratSizeSelectedValue = caratValue;

    // 🚫 Skip if triggered via code
    if (!e.isTrigger && headGlb && shankGlb) {
        vdbrcPendingThreeD = { headGlb: headGlb, shankGlb: shankGlb };
        const trackThreeD = !!(window.player && typeof window.player.beginThreeDLoad === "function");
        if (trackThreeD) window.player.beginThreeDLoad();
        let reveal = false;
        try {
            reveal = await handleThreeDPart(headGlb, shankGlb, vdbrcThreeDInitialized) !== false;
        } finally {
            if (trackThreeD) window.player.endThreeDLoad(reveal);
        }
    }
});

$('body').on('click', '.setting_pdp_toggle_btn', function () {
    const button = $(this);
    const type = $(this).data('type');
    const speed = 300;

    // Rotate the icon (assumes an <img> inside the button)
    button.find('img').toggleClass('is-rotated');
    
    const toggleMap = {
        diamond_setting: ['Shape', 'Carat Size'],
        head_setting: ['Head Style'],
        shank_setting: ['Shank Style', 'Metal', 'Color', 'Diamond Color', 'Band']
    };

    const optionTypes = toggleMap[type];
    if (!optionTypes) return;

    optionTypes.forEach(optionType => {
        $(`.vdbrc_setting_pdp_option[data-type="${optionType}"]:not(.d-none)`).stop(true, true).fadeToggle(speed);
    });
});

function renderHeadStyleOptions(optionData) {
    var wrapper = $('.vdbrc_setting_pdp_option[data-type="Head Style"]');
    var container = $('#vdbrc_head_style_container');

    if (!wrapper.length || !container.length) return;

    var filterOption = null;

    // Find Head Style option
    $.each(optionData, function (i, option) {
        if (option.label === 'Head Style') {
            filterOption = option;
            return false;
        }
    });

    if (!filterOption || !filterOption.values || !Object.keys(filterOption.values).length || vdbrcOptionSelectedMissing(filterOption.selected)) {
        wrapper.find('.vdbrc_selected_option_value').text('');
        wrapper.hide();
        container.hide();
        $(".vdbrc_head_section_header").hide();
        wrapper.addClass("d-none");
        return;
    }

    // If found → ensure visible
    wrapper.show();
    wrapper.removeClass("d-none");
    container.show();
    $(".vdbrc_head_section_header").show();

    // Set selected value
    wrapper.find('.vdbrc_selected_option_value').text(`: ${filterOption.selected}`);
    wrapper.find('.vdbrc_tooltip_text').text(filterOption.description);

    var html = '';
    var index = 0;

    $.each(filterOption.values, function (id, label) {
        var isActive = (label === filterOption.selected);
        var imageUrl = vdbrcHeadStyleImages[label] || Object.values(vdbrcHeadStyleImages)[0];
        var hiddenClass = index >= 4 ? ' vdbrc_head_style_hidden' : '';

        html += `
            <div class="spdp-head-card vdbrc_head_style_card${isActive ? ' active' : ''}${hiddenClass}"
                data-value-id="${id}"
                data-value-label="${label}"
                ${index >= 4 ? 'style="display: none;"' : ''}>
                ${imageUrl ? `<img src="${imageUrl}" class="spdp-head-imageobject-cover" alt="${label}">` : ''}
                <span class="spdp-head-label">${label}</span>
            </div>
        `;

        index++;
    });

    /* Show More / Show Less toggle card */
    if (index > 4) {
        html += `
            <div class="spdp-head-card vdbrc_head_style_toggle">
                <div class="spdp-show-toggle">
                    <svg class="plus-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.0002 3.33331V16.6666M16.6668 9.99998H3.3335" stroke="#141B34" stroke-width="1.25" stroke-linejoin="round"></path>
                    </svg>
                    <svg class="minus-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: none;">
                        <path d="M16.6668 9.99998H3.3335" stroke="#141B34" stroke-width="1.25" stroke-linejoin="round"></path>
                    </svg>
                </div>
                <span class="spdp-show-label">Show More</span>
            </div>
        `;
    }

    container.html(html);
    vdbrcRevealSelectedHiddenOption(container, 'vdbrc_head_style_hidden', 'vdbrc_head_style_toggle');
}
$('body').on('click', '#vdbrc_head_style_container .vdbrc_head_style_card', async function () {
    var clicked = $(this);
    var label = clicked.data('value-label');

    $('#vdbrc_head_style_container .vdbrc_head_style_card').removeClass('active');
    clicked.addClass('active');

    $('.vdbrc_setting_pdp_option[data-type="Head Style"] .vdbrc_selected_option_value').text(`: ${label}`);

    await vdbrcRefreshSubOptions();
});
$('body').on('click', '#vdbrc_head_style_container .vdbrc_head_style_toggle', function () {
    var container = $('#vdbrc_head_style_container');
    var hiddenItems = container.find('.vdbrc_head_style_hidden');
    var label = $(this).find('.spdp-show-label');
    var plusIcon = $(this).find('.plus-icon');
    var minusIcon = $(this).find('.minus-icon');

    if (hiddenItems.is(':visible')) {
        hiddenItems.hide();
        label.text('Show More');
        plusIcon.show();
        minusIcon.hide();
    } else {
        hiddenItems.show();
        label.text('Show Less');
        plusIcon.hide();
        minusIcon.show();
    }
});

function renderShankStyleOptions(optionData) {
    var wrapper = $('.vdbrc_setting_pdp_option[data-type="Shank Style"]');
    var container = $('#vdbrc_shank_style_container');

    if (!wrapper.length || !container.length) return;

    var filterOption = null;

    // Find Shank Style option
    $.each(optionData, function (i, option) {
        if (option.label === 'Shank Style') {
            filterOption = option;
            return false;
        }
    });

    if (!filterOption || !filterOption.values || !Object.keys(filterOption.values).length || vdbrcOptionSelectedMissing(filterOption.selected)) {
        wrapper.find('.vdbrc_selected_option_value').text('');
        wrapper.hide();
        container.hide();
        $(".vdbrc_shank_section_header").hide();
        wrapper.addClass("d-none");
        return;
    }

    // If found → ensure visible
    wrapper.show();
    wrapper.removeClass("d-none");
    container.show();
    $(".vdbrc_shank_section_header").show();

    // Set selected value
    wrapper.find('.vdbrc_selected_option_value').text(`: ${filterOption.selected}`);
    wrapper.find('.vdbrc_tooltip_text').text(filterOption.description);

    var html = '';
    var index = 0;

    $.each(filterOption.values, function (id, label) {
        var isActive = (label === filterOption.selected);
        var imageUrl = vdbrcShankStyleImages[label] || Object.values(vdbrcShankStyleImages)[0];
        var hiddenClass = index >= 4 ? ' vdbrc_shank_style_hidden' : '';

        html += `
            <div class="spdp-shank-card vdbrc_shank_style_card${isActive ? ' active' : ''}${hiddenClass}"
                data-value-id="${id}"
                data-value-label="${label}"
                ${index >= 4 ? 'style="display: none;"' : ''}>
                ${imageUrl ? `<img src="${imageUrl}" class="spdp-shank-imageobject-cover" alt="${label}">` : ''}
                <span class="spdp-shank-label">${label}</span>
            </div>
        `;

         index++;
    });

    /* Show More / Show Less toggle card */
    if (index > 4) {
        html += `
            <div class="spdp-shank-card vdbrc_shank_style_toggle">
                <div class="spdp-show-toggle">
                    <svg class="plus-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.0002 3.33331V16.6666M16.6668 9.99998H3.3335" stroke="#141B34" stroke-width="1.25" stroke-linejoin="round"></path>
                    </svg>
                    <svg class="minus-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: none;">
                        <path d="M16.6668 9.99998H3.3335" stroke="#141B34" stroke-width="1.25" stroke-linejoin="round"></path>
                    </svg>
                </div>
                <span class="spdp-show-label">Show More</span>
            </div>
        `;
    }

    container.html(html);
    vdbrcRevealSelectedHiddenOption(container, 'vdbrc_shank_style_hidden', 'vdbrc_shank_style_toggle');
}
$('body').on('click', '#vdbrc_shank_style_container .vdbrc_shank_style_card', async function () {
    var clicked = $(this);
    var label = clicked.data('value-label');

    $('#vdbrc_shank_style_container .vdbrc_shank_style_card').removeClass('active');
    clicked.addClass('active');

    $('.vdbrc_setting_pdp_option[data-type="Shank Style"] .vdbrc_selected_option_value').text(`: ${label}`);

    await vdbrcRefreshSubOptions();
});
$('body').on('click', '#vdbrc_shank_style_container .vdbrc_shank_style_toggle', function () {
    var container = $('#vdbrc_shank_style_container');
    var hiddenItems = container.find('.vdbrc_shank_style_hidden');
    var label = $(this).find('.spdp-show-label');
    var plusIcon = $(this).find('.plus-icon');
    var minusIcon = $(this).find('.minus-icon');

    if (hiddenItems.is(':visible')) {
        hiddenItems.hide();
        label.text('Show More');
        plusIcon.show();
        minusIcon.hide();
    } else {
        hiddenItems.show();
        label.text('Show Less');
        plusIcon.hide();
        minusIcon.show();
    }
});

function renderMetalOptions(optionData) {
    var wrapper = $('.vdbrc_setting_pdp_option[data-type="Metal"]');
    var container = $('#vdbrc_metal_container');

    if (!wrapper.length || !container.length) return;

    var filterOption = null;

    // Find Metal option
    $.each(optionData, function (i, option) {
        if (option.label === 'Metal') {
            filterOption = option;
            return false;
        }
    });

    if (!filterOption || !filterOption.values || !Object.keys(filterOption.values).length || vdbrcOptionSelectedMissing(filterOption.selected)) {
        wrapper.find('.vdbrc_selected_option_value').text('');
        wrapper.hide();
        container.hide();
        wrapper.addClass("d-none");
        return;
    }

    // If found → ensure visible
    wrapper.show();
    wrapper.removeClass("d-none");
    container.show();

    // Set selected value
    wrapper.find('.vdbrc_selected_option_value').text(`: ${filterOption.selected}`);
    wrapper.find('.vdbrc_tooltip_text').text(filterOption.description);

    var html = '';

    $.each(filterOption.values, function (id, label) {
        var isActive = (label === filterOption.selected);

        html += `
            <div class="spdp-metal-option vdbrc_metal_option${isActive ? ' active' : ''}"
                 data-value-id="${id}"
                 data-value-label="${label}">
                ${label}
            </div>
        `;

        if (isActive) {
            $(".vdbrc_setting_prod_metal_type").text(label);
        }
    });

    container.html(html);
}
$('body').on('click', '#vdbrc_metal_container .vdbrc_metal_option', async function () {
    var clicked = $(this);
    var label = clicked.data('value-label');

    $('#vdbrc_metal_container .vdbrc_metal_option').removeClass('active');
    clicked.addClass('active');

    $('.vdbrc_setting_pdp_option[data-type="Metal"] .vdbrc_selected_option_value').text(`: ${label}`);

    await vdbrcRefreshSubOptions();
});

function renderColorOptions(optionData) {
    var wrapper = $('.vdbrc_setting_pdp_option[data-type="Color"]');
    var container = $('#vdbrc_color_container');

    if (!wrapper.length || !container.length) return;

    var filterOption = null;

    // Find Color option
    $.each(optionData, function (i, option) {
        if (option.label === 'Color') {
            filterOption = option;
            return false;
        }
    });

    if (!filterOption || !filterOption.values || !Object.keys(filterOption.values).length || vdbrcOptionSelectedMissing(filterOption.selected)) {
        wrapper.find('.vdbrc_selected_option_value').text('');
        wrapper.hide();
        container.hide();
        wrapper.addClass("d-none");
        return;
    }

    // If found → ensure visible
    wrapper.show();
    wrapper.removeClass("d-none");
    container.show();

    // Set selected value
    wrapper.find('.vdbrc_selected_option_value').text(`: ${filterOption.selected}`);
    wrapper.find('.vdbrc_tooltip_text').text(filterOption.description);

    var html = '';

    $.each(filterOption.values, function (id, label) {
        var isActive = (label === filterOption.selected);
        var swatchUrl = vdbrcColorImages[label] || Object.values(vdbrcColorImages)[0];

        html += `
            <div class="spdp-color-card vdbrc_color_card${isActive ? ' active' : ''}"
                 data-value-id="${id}"
                 data-value-label="${label}">
                <div class="spdp-color-swatch">
                    ${swatchUrl ? `<img src="${swatchUrl}" alt="${label}">` : ''}
                </div>
                <span class="spdp-color-label">${label}</span>
            </div>
        `;

        if (isActive) {
            $(".vdbrc_engaving_preview").attr("src", engravingOptionImages[label] || '');
            $(".vdbrc_setting_prod_metal_color").text(label);
        }
    });

    container.html(html);
}
$('body').on('click', '#vdbrc_color_container .vdbrc_color_card', async function () {
    var clicked = $(this);
    var label = clicked.data('value-label');

    $('#vdbrc_color_container .vdbrc_color_card').removeClass('active');
    clicked.addClass('active');

    $('.vdbrc_setting_pdp_option[data-type="Color"] .vdbrc_selected_option_value').text(`: ${label}`);

    await vdbrcRefreshSubOptions();
});

function renderDiamondColorOptions(optionData) {
    var wrapper = $('.vdbrc_setting_pdp_option[data-type="Diamond Color"]');
    var container = $('#vdbrc_diamond_color_container');

    if (!wrapper.length || !container.length) return;

    var filterOption = null;

    // Find Diamond Color option
    $.each(optionData, function (i, option) {
        if (option.label === 'Diamond Color') {
            filterOption = option;
            return false;
        }
    });

    if (!filterOption || !filterOption.values || !Object.keys(filterOption.values).length || vdbrcOptionSelectedMissing(filterOption.selected)) {
        wrapper.find('.vdbrc_selected_option_value').text('');
        wrapper.hide();
        container.hide();
        wrapper.addClass("d-none");
        return;
    }

    // If found → ensure visible
    wrapper.show();
    wrapper.removeClass("d-none");
    container.show();

    // Set selected value
    wrapper.find('.vdbrc_selected_option_value').text(`: ${filterOption.selected}`);
    wrapper.find('.vdbrc_tooltip_text').text(filterOption.description);

    var html = '';
    var index = 0;

    $.each(filterOption.values, function (id, label) {
        var isActive = (label === filterOption.selected);
        var imageUrl = vdbrcDiamondColorImages[label] || Object.values(vdbrcDiamondColorImages)[0];
        var hiddenClass = index >= 4 ? ' vdbrc_diamond_hidden' : '';

        html += `
            <div class="spdp-diamond-card vdbrc_diamond_card${isActive ? ' active' : ''}${hiddenClass}"
                 data-value-id="${id}"
                 data-value-label="${label}"
                 ${index >= 4 ? 'style="display: none;"' : ''}>
                ${imageUrl ? `<img src="${imageUrl}" class="spdp-diamond-swatchobject-cover" alt="${label}">` : ''}
                <span class="spdp-diamond-label">${label}</span>
            </div>
        `;

        index++;
    });

    // Add toggle card if more than 4
    if (index > 4) {
        html += `
            <div class="spdp-diamond-card vdbrc_diamond_toggle">
                <div class="spdp-show-toggle">
                    <svg class="plus-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.0002 3.33331V16.6666M16.6668 9.99998H3.3335" stroke="#141B34" stroke-width="1.25" stroke-linejoin="round"></path>
                    </svg>
                    <svg class="minus-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: none;">
                        <path d="M16.6668 9.99998H3.3335" stroke="#141B34" stroke-width="1.25" stroke-linejoin="round"></path>
                    </svg>
                </div>
                <span class="spdp-show-label">Show More</span>
            </div>
        `;
    }

    container.html(html);
    vdbrcRevealSelectedHiddenOption(container, 'vdbrc_diamond_hidden', 'vdbrc_diamond_toggle');
}
$('body').on('click', '#vdbrc_diamond_color_container .vdbrc_diamond_card', async function () {
    if ($(this).hasClass('vdbrc_diamond_toggle')) return;

    var clicked = $(this);
    var label = clicked.data('value-label');

    $('#vdbrc_diamond_color_container .vdbrc_diamond_card').removeClass('active');
    clicked.addClass('active');

    $('.vdbrc_setting_pdp_option[data-type="Diamond Color"] .vdbrc_selected_option_value').text(`: ${label}`);

    await vdbrcRefreshSubOptions();
});
$('body').on('click', '#vdbrc_diamond_color_container .vdbrc_diamond_toggle', function () {
    var container = $('#vdbrc_diamond_color_container');
    var hiddenItems = container.find('.vdbrc_diamond_hidden');
    var label = $(this).find('.spdp-show-label');
    var plusIcon = $(this).find('.plus-icon');
    var minusIcon = $(this).find('.minus-icon');

    if (hiddenItems.is(':visible')) {
        hiddenItems.hide();
        label.text('Show More');
        plusIcon.show();
        minusIcon.hide();
    } else {
        hiddenItems.show();
        label.text('Show Less');
        plusIcon.hide();
        minusIcon.show();
    }
});

function renderBandOptions(optionData) {
    var wrapper = $('.vdbrc_setting_pdp_option[data-type="Band"]');
    var container = $('#vdbrc_band_container');

    if (!wrapper.length || !container.length) return;


    var filterOption = null;

    // Find Band option
    $.each(optionData, function (i, option) {
        if (option.label === 'Band') {
            filterOption = option;
            return false;
        }
    });

    if (!filterOption || !filterOption.values || !Object.keys(filterOption.values).length || vdbrcOptionSelectedMissing(filterOption.selected)) {
        wrapper.find('.vdbrc_selected_option_value').text('');
        wrapper.hide();
        container.hide();
        wrapper.addClass("d-none");
        return;
    }

    // If found → ensure visible
    wrapper.show();
    wrapper.removeClass("d-none");
    container.show();

    // Set selected value
    wrapper.find('.vdbrc_selected_option_value').text(`: ${filterOption.selected}`);
    wrapper.find('.vdbrc_tooltip_text').text(filterOption.description);

    var html = '';

    // Band values are an array in your API: ["0","1","2"...]
    $.each(filterOption.values, function (i, value) {
        var isActive = (String(value) === String(filterOption.selected));

        html += `
            <div class="spdp-band-option vdbrc_band_option${isActive ? ' active' : ''}"
                 data-value-label="${value}">
                ${value}
            </div>
        `;
    });

    container.html(html);
}
$('body').on('click', '#vdbrc_band_container .vdbrc_band_option', async function () {
    var clicked = $(this);
    var label = clicked.data('value-label');

    $('#vdbrc_band_container .vdbrc_band_option').removeClass('active');
    clicked.addClass('active');

    $('.vdbrc_setting_pdp_option[data-type="Band"] .vdbrc_selected_option_value').text(`: ${label}`);

    await vdbrcRefreshSubOptions();
});


async function get_setting_info(productHandle) {
    if (!productHandle) {
        console.error("Product handle is required");
        return null;
    }

    if (vdbrcSettingInfoCache.has(productHandle)) {
        return vdbrcSettingInfoCache.get(productHandle);
    }

    const sendData = new URLSearchParams();
    sendData.append("action", "fetch_product_options");
    sendData.append("shop", shop);
    sendData.append("handle", productHandle);

    try {
        const responseData = await new Promise((resolve, reject) => {
            $.post(API_URL, sendData.toString(), (resultData) => {
                try {
                    const parsed = JSON.parse(resultData);
                    resolve(parsed);
                } catch (e) {
                    reject("Invalid JSON response: " + e);
                }
            }).fail((error) => reject(error));
        });

        if (responseData) {
            vdbrcSettingInfoCache.set(productHandle, responseData);
        }

        return responseData;

    } catch (error) {
        console.error("Error loading stones:", error);
        return null;
    }
}

async function get_sub_options(groupId, attributeInfo) {
    if (!groupId) return null;

    delete attributeInfo["Carat Size"];

    const cacheKey = groupId + '|' + JSON.stringify(attributeInfo);
    if (vdbrcSubOptionsCache.has(cacheKey)) {
        return vdbrcSubOptionsCache.get(cacheKey);
    }
    
    var sendData = new URLSearchParams();
    sendData.append("action", "fetch_sub_options_v2");
    sendData.append("shop", shop);
    sendData.append("group_id", groupId);
    sendData.append("attribute_info", JSON.stringify(attributeInfo));

    try {
        var responseData = await new Promise((resolve, reject) => {
            $.post(API_URL, sendData.toString(), (resultData) => {
                try {
                    var parsed = JSON.parse(resultData);
                    resolve(parsed);
                } catch (e) {
                    reject("Invalid JSON response: " + e);
                }
            }).fail((error) => reject(error));
        });

        if (responseData) {
            vdbrcSubOptionsCache.set(cacheKey, responseData);
        }

        return responseData;
    } catch (error) {
        console.error("Error loading sub options:", error);
        return null;
    }
}

function vdbrcOptionValue($section) {
    const labelText = $section.find(".vdbrc_selected_option_value").first().text() || "";
    const cleaned = $.trim(String(labelText).replace(/^:\s*/, ""));
    if (cleaned !== "" && cleaned.toLowerCase() !== "null") return cleaned;

    const $active = $section.find(".active").first();
    return $.trim($active.attr("data-value-label") || $active.attr("data-carat") || $active.text() || "");
}

function vdbrcGetAttributeInfoFromUI(isAtc = false) {
    let result = {};
    let hasPlatinum = false;

    $(".vdbrc_setting_pdp_option").each(function () {
        const $section = $(this);
        if ($section.hasClass("d-none")) return;

        const type = $section.attr("data-type");
        if (!type) return;

        const cleaned = vdbrcOptionValue($section);

        if (cleaned !== "") {
            result[type] = cleaned;
        }

        if (type === "Metal") {
            if (cleaned.toLowerCase().includes("platinum")) {
                hasPlatinum = true;
                $('.vdbrc_setting_pdp_option[data-type="Color"]').hide();
                $('.vdbrc_setting_pdp_option[data-type="Color"]').addClass('d-none');
            } else {
                $('.vdbrc_setting_pdp_option[data-type="Color"]').show();
                $('.vdbrc_setting_pdp_option[data-type="Color"]').removeClass('d-none');
            }
        }
    });

    // Remove Color after loop completes
    if (hasPlatinum) {
        delete result["Color"];
    }

    if (isAtc) {
        // Ring size (hidden input)
        const ringSize = $.trim($('.vdbrc_ring_size_input').val() || "");
        if (ringSize !== "") {
            result["Ring Size"] = ringSize;
        }

        const $engraving = $(".vdbrc_engaving_details");
        const engravingText = $.trim($engraving.attr("data-engraving-text") || $engraving.data("engraving-text") || "");
        if (engravingText !== "") {
            result["Engraving Text"] = engravingText;
        }
        const engravingFont = $.trim($engraving.attr("data-engraving-font") || $engraving.data("engraving-font") || "");
        if (engravingFont !== "") {
            result["Engraving Font"] = engravingFont;
        }

    }

    return result;
}

function vdbrcSetStoneButtonData(attrs) {
    const $buttons = $(".vdbrc_add_to_cart_btn, .vdbrc_final_add_to_cart");
    $.each(attrs, function (name, value) {
        $buttons.attr(name, value == null ? "" : value);
    });
}

function vdbrcPairId(stockNum) {
    const handle = $(".vdbrc_complete_my_ring_btn").attr("data-product-handle") || "";
    return handle + "|" + (stockNum || "");
}

function vdbrcReviewPageUrl() {
    const params = vdbrcCurrentParams();
    const handle = $(".vdbrc_complete_my_ring_btn").attr("data-product-handle") || params.get("ring-handle") || "";
    if (handle) params.set("ring-handle", handle);
    params.set("steps", "settings");
    params.set("review", "true");
    params.delete("change_flow");
    const path = handle ? "/products/" + handle : window.location.pathname;
    return vdbrcBuildUrl(path, params);
}

function vdbrcPutProperty(props, key, value) {
    const cleaned = $.trim(value == null ? "" : String(value));
    if (cleaned !== "" && cleaned !== "-") {
        props[key] = cleaned;
    }
}

function vdbrcStoneLineProperties($btn, reviewUrl) {
    const props = {};
    const stockNum = $btn.attr("data-stone-stock-num") || "";
    vdbrcPutProperty(props, "Shape", $btn.attr("data-stone-shape"));
    vdbrcPutProperty(props, "Carat", $btn.attr("data-stone-carat"));
    vdbrcPutProperty(props, "Color", $btn.attr("data-stone-color"));
    vdbrcPutProperty(props, "Clarity", $btn.attr("data-stone-clarity"));
    vdbrcPutProperty(props, "Cut", $btn.attr("data-stone-cut"));
    vdbrcPutProperty(props, "Polish", $btn.attr("data-stone-polish"));
    vdbrcPutProperty(props, "Lab", $btn.attr("data-stone-lab"));
    vdbrcPutProperty(props, "Certificate Number", $btn.attr("data-stone-certificate"));
    vdbrcPutProperty(props, "Origin", $btn.attr("data-stone-origin"));
    vdbrcPutProperty(props, "Stock Number", stockNum);
    vdbrcPutProperty(props, "_Stock ID", $btn.attr("data-stone-stock-id"));
    vdbrcPutProperty(props, "_Vendor ID", $btn.attr("data-vendor-id"));
    vdbrcPutProperty(props, "_Vendor Name", $btn.attr("data-vendor-name"));
    if (reviewUrl) props["_Review URL"] = reviewUrl;
    props["_Pair ID"] = vdbrcPairId(stockNum);
    props["_Line Role"] = "Stone";
    return props;
}

function vdbrcSettingLineProperties($btn, reviewUrl) {
    const stockNum = ($btn && $btn.length) ? ($btn.attr("data-stone-stock-num") || "") : "";
    const props = vdbrcGetAttributeInfoFromUI(true);
    if (reviewUrl) props["_Review URL"] = reviewUrl;
    props["_Pair ID"] = vdbrcPairId(stockNum);
    props["_Line Role"] = "Setting";
    return props;
}

function vdbrcSetAddingState($button, isAdding) {
    if (isAdding) {
        if ($button.data("vdbrcOriginalHtml") == null) {
            $button.data("vdbrcOriginalHtml", $button.html());
        }
        $button.prop("disabled", true).attr("aria-busy", "true").html("Adding to cart…");
        return;
    }

    const original = $button.data("vdbrcOriginalHtml");
    if (original != null) $button.html(original);
    $button.prop("disabled", false).removeAttr("aria-busy");
}

function vdbrcRequireRingSize() {
    const ringSize = $.trim($(".vdbrc_ring_size_input").val() || "");
    if (ringSize === "") {
        alert("Please select a ring size before proceeding to cart.");
        return false;
    }
    return true;
}

var vdbrcRequestSeq = 0;
async function vdbrcRefreshSubOptions() {
    vdbrcRequestSeq += 1;
    var currentSeq = vdbrcRequestSeq;
    const trackThreeD = !!(window.player && typeof window.player.beginThreeDLoad === "function");
    if (trackThreeD) window.player.beginThreeDLoad();
    let revealThreeD = false;

    try {
    var attributeInfo = vdbrcGetAttributeInfoFromUI();
    var response = await get_sub_options(vdbrcSettingProductGroupId, attributeInfo);

    if (!response || response.status !== 'success' || !response.data || !response.data.option_data) return;

    // Avoid race condition if multiple clicks happen fast
    if (currentSeq !== vdbrcRequestSeq) return;

    let optionData = response.data.option_data;

    renderAllOptionsFromResponse(optionData);

    // Replace handle in url without reloading the page 
    if (response.data.pro_handle) {
        // var newUrl = window.location.protocol + "//" + window.location.host + "/products/" + response.data.pro_handle;
        // window.history.replaceState({ path: newUrl }, '', newUrl);

        const url = new URL(window.location.href);

        // Replace only the product handle
        url.pathname = `/products/${response.data.pro_handle}`;

        // Keep query params and hash automatically
        window.history.replaceState({}, '', url.toString());

        $('.vdbrc_complete_my_ring_btn').attr('data-product-handle', response.data.pro_handle);
    }

    let product_data = response.data.product_data;

    if (product_data) {
        $('.vdbrc_setting_prod_title').text(product_data.prod_title || '');

        const price_without_format = vdbrcApplySettingPrice(product_data);
        const formattedDescription = product_data.description
            .replace(/\n\n/g, '<br><br>')
            .replace(/\n/g, '<br>');

        // $('.vdbrc_setting_prod_description').html(formattedDescription || '');
        let description = product_data.description || '';
        // Convert <br> to newlines
        description = description.replace(/<br\s*\/?>/gi, '\n');
        // Strip all remaining HTML tags
        description = $('<div>').html(description).text();
        // Get first sentence
        description = description.split('.')[0] + '.';
        // Convert newlines back to <br>
        description = description.replace(/\n/g, '<br>');
        $('.vdbrc_setting_prod_description .description-content').html(description);
        $('.vdbrc_stone_description').html(formattedDescription || '');
        $('.vdbrc_add_to_cart_btn').attr('data-variant-id', product_data.variant_id || '');
        $('.vdbrc_final_add_to_cart').attr('data-variant-id', product_data.variant_id || '');
        $(".vdbrc_subtotal_price").attr('data-setting-price', price_without_format);

        let stonePrice = $(".vdbrc_subtotal_price").attr('data-stone-price') || 0;
        let settingPrice = $(".vdbrc_subtotal_price").attr('data-setting-price') || 0;
        let subtotalPrice = vdbrcFormatMoney((Number(stonePrice) + Number(settingPrice)) * 100, market_currency_symbol + " {amount}");
        $(".vdbrc_subtotal_price").html(subtotalPrice);

        const images = (product_data?.images && product_data.images != "") ? (product_data.images).split(",") : [];
        if (images.length > 0) {
            const $track = $(".vdbrc_gallery_slider");     // your slider track container
            $track.empty();

            let sliderImageArray = [];
            if(isMobileDevice()) {
                sliderImageArray = images.slice(0, 11); // We will display 1-10 index images in slider
            }else{
                sliderImageArray = images.slice(1, 11); // We will display 1-10 index images in slider
            }

            if (sliderImageArray.length > 0) {
                // build slides dynamically
                sliderImageArray.forEach(function (url, i) {
                    url = (url || "").trim();
                    if (!url) return;

                    $track.append(`
                            <div class="slide ${i === 0 ? "active" : ""}">
                                <img src="${url}" alt="Ring ${i + 1}" class="stonepdp-gallery-image">
                            </div>
                        `);
                });

                initSimpleSlider(".simple-slider");
                initSimpleSlider(".simple-slider-mobile");
            } else {
                $(".vdbrc_gallery_slider_container").hide();
            }

            if (images[2] && images[2].trim() != "") {
                $(".vdbrc_setting_ring_on_hand_image").attr('src', images[2]).show();
            } else {
                $(".vdbrc_setting_ring_on_hand_image_container").hide();
            }

            if (images[11] && images[11].trim() != "") {
                $(".vdbrd_setting_hand_view_image").attr('src', images[11]).show();
            } else {
                $(".vdbrc_setting_hand_view_container").hide();
            }
        }

        const video_url = product_data?.videos || '';
        if (video_url) {
            $(".vdbrc_setting_video").attr('src', video_url).show();
        } else {
            $(".vdbrc_setting_video_container").hide();
        }

        const caratGlbMap = {};
        if (product_data?.carat_glbs && product_data.carat_glbs != "") {
            const glbArray = product_data.carat_glbs.split(",");

            glbArray.forEach(item => {
                const parts = item.split("|");

                if (parts.length === 3) {
                    let caratStr = parts[0].replace("CT", "").trim(); // "1.00CT" → "1.00"
                    let carat = parseFloat(caratStr);

                    caratGlbMap[carat] = {
                        head_glb: parts[1],
                        shank_glb: parts[2]
                    };
                }
            });
        }

        const caratArray = (product_data?.carat_images && product_data.carat_images != "") ? (product_data.carat_images).split(",") : [];
        if (caratArray.length > 0) {
            $('.vdbrc_setting_pdp_option[data-type="Carat Size"]').show();

            let formattedCaratData = $.map(caratArray, function (item) {
                const firstColonIndex = item.indexOf(":");
                const caratValue = item.substring(0, firstColonIndex);
                const imageURL = item.substring(firstColonIndex + 1);
                return {
                    carat: parseFloat(caratValue),
                    image: imageURL
                };
            });

            formattedCaratData.sort(function (a, b) {
                return a.carat - b.carat;
            });

            const container = $("#vdbrc_carat_options_container");
            container.empty();

            $.each(formattedCaratData, function (index, item) {
                const glbData = caratGlbMap[item.carat] || {};

                const div = $("<div>", {
                    class: "spdp-carat-option",
                    text: item.carat,
                    "data-image": item.image,
                    "data-carat": item.carat,
                    "data-head-glb": glbData.head_glb || "",
                    "data-shank-glb": glbData.shank_glb || ""
                });

                container.append(div);
            });

            if (vdbrcCaratSizeSelectedValue) {
                container.find(`.spdp-carat-option[data-carat="${vdbrcCaratSizeSelectedValue}"]`).trigger("click");
            } else {
                container.find(".spdp-carat-option").first().trigger("click");
            }
        }else{
            $('.vdbrc_setting_pdp_option[data-type="Carat Size"]').hide();
        }

        const metaFieldJson = product_data?.metafield_json ? JSON.parse(product_data.metafield_json) : null;
        if (metaFieldJson && Array.isArray(metaFieldJson)) {
            function getValue(key) {
                const item = metaFieldJson.find(obj => obj.key === key);
                return item && item.value ? item.value : "-";
            }
            $(".vdbrc_setting_prod_height").text(getValue("VDB Ring Height"));
            $(".vdbrc_setting_prod_width").text(getValue("VDB Ring Width"));
            $(".vdbrc_setting_prod_carat").text(getValue("VDB Ring Avg Total Carat"));
            $(".vdbrc_setting_prod_color").text(getValue("VDB Ring Avg Color"));
            $(".vdbrc_setting_prod_clarity").text(getValue("VDB Ring Avg Clarity"));
            $(".vdbrc_setting_prod_finish").text(getValue("VDB Ring Rhodium Finish"));
            $(".vdbrc_setting_prod_quantity").text(getValue("VDB Ring Quantity"));
            $(".vdbrc_setting_prod_measurement").text(getValue("VDB Ring Measurement"));
        }

        const selectedCarat = caratGlbMap[vdbrcCaratSizeSelectedValue];
        const head_glb = selectedCarat?.head_glb;
        const shank_glb = selectedCarat?.shank_glb;

        if (head_glb && shank_glb && head_glb !== "" && shank_glb !== "") {
            vdbrcPendingThreeD = { headGlb: head_glb, shankGlb: shank_glb };
            revealThreeD = await handleThreeDPart(head_glb, shank_glb, vdbrcThreeDInitialized) !== false;
        } else if (product_data?.head_glb && product_data?.shank_glb && product_data?.head_glb !== "" && product_data?.shank_glb !== ""){
            vdbrcPendingThreeD = { headGlb: product_data.head_glb, shankGlb: product_data.shank_glb };
            revealThreeD = await handleThreeDPart(product_data.head_glb, product_data.shank_glb, vdbrcThreeDInitialized) !== false;
        }

        $('.vdbrc_setting_prod_image').hide();
    }

    if (optionData.length > 0) {
        var shankStyle = $.grep(optionData, function (item) {
            return item.label === "Shank Style";
        })[0].selected;


        var headStyle = $.grep(optionData, function (item) {
            return item.label === "Head Style";
        })[0].selected;

        $(".vdbrc_setting_shank_style").text(shankStyle);
        $(".vdbrc_setting_head_style").text(headStyle);
    }
    } finally {
        if (trackThreeD) window.player.endThreeDLoad(revealThreeD && currentSeq === vdbrcRequestSeq);
    }
}

//#region : Engraving Popup Logic
$('body').on('click', '.spdp-engraving-toggle', function (e) {
    e.preventDefault();
    const $overlay = $('.vdbrc_engraving_overlay');
    $overlay.addClass('active');
    $('body').css('overflow', 'hidden');
    // set default font
    $overlay.find('.vdbrc_preview_text').addClass('font-betham');
});
$('body').on('click', '.vdbrc_engraving_remove', function (e) {
    e.preventDefault();
    const $toggle = $('.spdp-engraving-toggle');
    $toggle.find('span').text('Add Free Engraving');
    $('.vdbrc_engaving_details')
        .attr('data-engraving-text', '')
        .attr('data-engraving-font', '');
    $('.vdbrc_engraving_input_wrapper input').val('');
    $('.vdbrc_engraving_input_wrapper').addClass('d-none');
});
function closePopupForEngraving($overlay) {
    $overlay.removeClass('active');
    $('body').css('overflow', '');
}
$('body').on('click', '.vdbrc_engraving_close', function () {
    const $overlay = $(this).closest('.vdbrc_engraving_overlay');
    closePopupForEngraving($overlay);
});
$('body').on('click', '.vdbrc_engraving_overlay', function (e) {
    if ($(e.target).is('.vdbrc_engraving_overlay')) {
        closePopupForEngraving($(this));
    }
});
$('body').on('click', '.spdp-font-option', function () {
    const $this = $(this);
    const $overlay = $this.closest('.vdbrc_engraving_overlay');
    $overlay.find('.spdp-font-option').removeClass('active');
    $this.addClass('active');
    const selectedFont = $this.find('span').data('font');
    const $previewText = $overlay.find('.vdbrc_preview_text');
    $previewText
        .removeClass('font-1 font-2 font-3 font-4 font-5')
        .removeClass('font-betham font-asset font-medievalsharp font-radley font-prata')
        .addClass(selectedFont);
});
$('body').on('input', '.vdbrc_engraving_input', function () {
    const $input = $(this);
    const $overlay = $input.closest('.vdbrc_engraving_overlay');
    const text = $input.val();
    const remaining = 20 - text.length;
    $overlay.find('.vdbrc_char_count').text(remaining);
    $overlay.find('.vdbrc_preview_text').text(text);
});
$('body').on('click', '.vdbrc_save_engraving', function () {
    const $overlay = $(this).closest('.vdbrc_engraving_overlay');
    const $toggle = $('.spdp-engraving-toggle');
    const engravingText = $overlay.find('.vdbrc_engraving_input').val();
    const selectedFont = $overlay.find('.spdp-font-option.active span').data('font');
    if (engravingText.trim() !== '') {
        $toggle.find('span').text('Engraving: ' + engravingText);
        $('.vdbrc_engaving_details')
            .attr('data-engraving-text', engravingText)
            .attr('data-engraving-font', selectedFont);

        document.cookie = `vdbrc_setting_engraving_text=${engravingText}`;
        document.cookie = `vdbrc_setting_engraving_font=${selectedFont}`;

        $('.vdbrc_engraving_input_wrapper input').val(engravingText);
        $('.vdbrc_engraving_input_wrapper').removeClass('d-none');
    } else {
        $toggle.find('span').text('Add Free Engraving');
        $('.vdbrc_engaving_details')
            .data('engraving-text', '')
            .data('engraving-font', '');

        document.cookie = `vdbrc_setting_engraving_text=`;
        document.cookie = `vdbrc_setting_engraving_font=`;

        $('.vdbrc_engraving_input_wrapper input').val('');
        $('.vdbrc_engraving_input_wrapper').addClass('d-none');
        $('.vdbrc_engraving_remove').trigger('click');
    }
    closePopupForEngraving($overlay);
});
//#endregion

//#region : Ring Size Chart Popup Logic
$('body').on('click', '.spdp-ring-size-link', function (e) {
    e.preventDefault();

    const $overlay = $('.vdbrc_ring_size_popup_overlay');

    $overlay.addClass('active');
    $('body').css('overflow', 'hidden');
});
function closePopupForRingSize() {
    const $overlay = $('.vdbrc_ring_size_popup_overlay');

    $overlay.removeClass('active');
    $('body').css('overflow', '');
}
$('body').on('click', '.vdbrc_ring_size_popup_close', function () {
    closePopupForRingSize();
});
$('body').on('click', '.vdbrc_ring_size_popup_overlay', function (e) {
    if ($(e.target).is('.vdbrc_ring_size_popup_overlay')) {
        closePopupForRingSize();
    }
});
//#endregion

$('body').on('click', '.vdbrc_complete_my_ring_btn', function () {
    const params = vdbrcCurrentParams();
    const productHandle = $(this).attr('data-product-handle');

    const ringSize = $.trim($('.vdbrc_ring_size_input').val() || "");
    if (ringSize === "") {
        alert("Please select a ring size before proceeding.");
        return;
    }

    // Reset per click (no stale state)
    const isStoneSelected =
        (params.has('labgrown_stock_num') && params.get('labgrown_stock_num').trim() !== '') ||
        (params.has('natural_stock_num') && params.get('natural_stock_num').trim() !== '');

    // The setting is confirmed at this point, so it becomes the selected ring
    params.set('ring-handle', productHandle);
    params.delete('change_flow');

    // If stone is selected, go to product page and keep all params + add extras
    if (isStoneSelected) {
        // keep existing params and add/overwrite these 
        params.set('steps', 'settings');
        params.set('review', 'true');

        window.location.href = vdbrcBuildUrl(`/products/${productHandle}`, params);
        return;
    }

    const settingSelectedShape = $('.vdbrc_setting_pdp_option[data-type="Shape"] .vdbrc_selected_option_value').text().replace(/^:\s*/, '');

    if(settingSelectedShape != ''){
        params.set('shape', settingSelectedShape);
    }

    params.delete('review');

    window.location.href = vdbrcBuildUrl('/collections/stones', params);
});

$('body').on('click', '.vdbrc_add_to_cart_btn', async function () {
    const $btn = $(this);
    if ($btn.prop('disabled')) return;
    if (!vdbrcRequireRingSize()) return;

    if (await vdbrcCartContainsVariant($btn.attr('data-variant-id'))) {
        if (isRedirectToCartPage) {
            window.location.href = '/cart';
        } else {
            try {
                await vdbrcOpenUpdatedCartDrawer();
            } catch (error) {
                console.error('Error while opening the cart:', error);
                alert(error.message || 'Something went wrong while adding to cart.');
            }
        }
        return;
    }

    vdbrcSetAddingState($btn, true);
    try {
        const stockNum = $btn.attr('data-stone-stock-num') || '';
        const reviewUrl = stockNum ? vdbrcReviewPageUrl() : '';
        await vdbrcUpsertCartLine($btn.attr('data-variant-id'), vdbrcSettingLineProperties($btn, reviewUrl));
        if (isRedirectToCartPage) {
            window.location.href = '/cart';
        } else {
            await vdbrcOpenUpdatedCartDrawer();
            vdbrcSetAddingState($btn, false);
        }
    } catch (error) {
        console.error('Error while adding to cart:', error);
        alert(error.message || 'Something went wrong while adding to cart.');
        vdbrcSetAddingState($btn, false);
    }
});

$('body').on('click', '.vdbrc_final_add_to_cart', async function () {
    const $btn = $(this);
    if ($btn.prop('disabled') || $btn.attr('data-vdbrc-locked') === 'true') return;
    if (!vdbrcRequireRingSize()) return;

    const $buy = $('.srevi-actions-box .srevi-btn-buy');
    vdbrcSetAddingState($btn, true);
    $buy.attr('data-vdbrc-locked', 'true').css('pointer-events', 'none');
    try {
        const stockNum = $btn.attr('data-stone-stock-num') || '';
        const reviewUrl = vdbrcReviewPageUrl();
        if (stockNum) {
            await addStoneToCart($btn, reviewUrl);
        }
        await vdbrcUpsertCartLine($btn.attr('data-variant-id'), vdbrcSettingLineProperties($btn, reviewUrl));
        if (isRedirectToCartPage) {
            window.location.href = '/cart';
        } else {
            await vdbrcOpenUpdatedCartDrawer();
            vdbrcSetAddingState($btn, false);
            $buy.removeAttr('data-vdbrc-locked').css('pointer-events', '');
        }
    } catch (error) {
        console.error('Error while adding to cart:', error);
        alert(error.message || 'Something went wrong while adding to cart.');
        vdbrcSetAddingState($btn, false);
        $buy.removeAttr('data-vdbrc-locked').css('pointer-events', '');
    }
});

$('body').on('click', '.srevi-actions-box .srevi-btn-buy', async function () {
    const $buy = $(this);
    if ($buy.prop('disabled') || $buy.attr('data-vdbrc-locked') === 'true') return;
    if (!vdbrcRequireRingSize()) return;

    const $cartBtn = $('.srevi-actions-box .vdbrc_final_add_to_cart').first();
    vdbrcSetAddingState($buy, true);
    $cartBtn.attr('data-vdbrc-locked', 'true').css('pointer-events', 'none');
    try {
        const stockNum = $cartBtn.attr('data-stone-stock-num') || '';
        const reviewUrl = vdbrcReviewPageUrl();
        await fetch('/cart/clear.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin'
        });
        if (stockNum) {
            await addStoneToCart($cartBtn, reviewUrl);
        }
        await shopifyAddToCart($cartBtn.attr('data-variant-id'), 1, vdbrcSettingLineProperties($cartBtn, reviewUrl));
        window.location.href = '/checkout';
    } catch (error) {
        console.error('Error while processing checkout:', error);
        alert(error.message || 'Something went wrong. Please try again.');
        vdbrcSetAddingState($buy, false);
        $cartBtn.removeAttr('data-vdbrc-locked').css('pointer-events', '');
    }
});

$('body').on('click', '.vdbrc_product_thumbnail_btn', function () {
    const button = $(this);
    const image = button.data('image');
    const video = button.data('video');

    const videoElement = $('.vdb_stone_video');
    const imageElement = $('.vdbrc_product_image');

    // If no video available, do nothing
    if (!video) return;

    // Toggle behavior
    if (button.hasClass('video_active')) {
        // Currently showing video → switch to image
        videoElement.hide().attr('src', '');
        imageElement.show();

        button.removeClass('video_active');
        $('.vdbrc_stone_image_icon').hide();
        $('.vdbrc_stone_video_icon').show();
    } else {
        // Currently showing image → switch to video
        const videoSrc = videoElement.data('src') || video;

        videoElement.attr('src', videoSrc).show();
        imageElement.hide();

        button.addClass('video_active');
        $('.vdbrc_stone_image_icon').show();
        $('.vdbrc_stone_video_icon').hide();
    }
});

$('body').on('click', '.vdbrc_thumb_3d_btn', function () {
    $(".vdbrc_gallery_slider_container[data-media-display-device-type='mobile']").hide();
    $("#webgl_vdb_canvas").show();
    // Ensure WebGL is initialized if the idle callback has not run yet
    if (!vdbrcThreeDInitialized && vdbrcPendingThreeD) {
        handleThreeDPart(vdbrcPendingThreeD.headGlb, vdbrcPendingThreeD.shankGlb, false);
    }
});
$('body').on('click', '.vdbrc_thumb_image_btn', function () {
    $(".vdbrc_gallery_slider_container[data-media-display-device-type='mobile']").show();
    $(".vdbrc_gallery_slider_container[data-media-display-device-type='mobile']").removeClass('d-none');
    $("#webgl_vdb_canvas").hide();
});
$('body').on('click', '.vdbrc_thumb_video_btn', function () {
    $(".vdbrc_gallery_slider_container[data-media-display-device-type='mobile']").hide();
    $("#webgl_vdb_canvas").hide();
    $(".vdbrc_video_wrapper").show();
    $(".vdbrc_video_wrapper").removeClass('d-none');
});

function vdbrcVendorIdFromUrl() {
    const params = vdbrcCurrentParams();
    return (params.get('vendor_id') || params.get('vendor-id') || params.get('vendorId') || '').trim();
}

function vdbrcNormalizeStockId(value) {
    const raw = String(value == null ? '' : value).trim();
    if (/^\d+\.0+$/.test(raw)) return String(parseInt(raw, 10));
    return raw;
}

function vdbrcStoneImageForApi(image) {
    const value = String(image || '').trim();
    if (!value) return '';
    if (value.indexOf('//') === 0) return 'https:' + value;
    if (!/^https?:\/\//i.test(value)) return '';
    return value;
}

function vdbrcParseApiJson(resultData) {
    if (resultData && typeof resultData === 'object') return resultData;
    const text = typeof resultData === 'string' ? resultData.replace(/^\uFEFF/, '').trim() : '';
    if (!text) return null;
    try {
        return JSON.parse(text);
    } catch (error) {
        console.error('Ring builder response was not valid JSON', error);
        return null;
    }
}

function vdbrcPostApi(body) {
    return new Promise((resolve, reject) => {
        $.post(API_URL, body, (resultData) => {
            resolve(vdbrcParseApiJson(resultData));
        }).fail(() => {
            reject(new Error('The diamond could not be added to the cart. Please try again.'));
        });
    });
}

function vdbrcProductInfoReady(responseData) {
    return !!(responseData && responseData.success && responseData.data && responseData.data.var_id);
}

async function get_stone_info(stone_stock_num, stockNumParam) {
    if (!stone_stock_num) {
        console.error("Stone stock number is required");
        return null;
    }

    const sendData = new URLSearchParams();
    sendData.append("action", "get_stone_details");
    sendData.append("shop", shop);
    sendData.append(stockNumParam, stone_stock_num);
    const vendorId = vdbrcVendorIdFromUrl();
    if (vendorId) sendData.append("vendor_id", vendorId);

    try {
        const responseData = await new Promise((resolve, reject) => {
            $.post(API_URL, sendData.toString(), (resultData) => {
                try {
                    const parsed = vdbrcParseApiJson(resultData);
                    if (parsed && parsed.success === true && parsed.data && window.vdbrcApplyDetailsCertificate) {
                        window.vdbrcApplyDetailsCertificate(parsed.data);
                    }
                    resolve(parsed);
                } catch (e) {
                    reject(e);
                }
            }).fail((error) => reject(error));
        });

        return responseData;

    } catch (error) {
        console.error("Error loading stones:", error);
        return null;
    }
}

async function vdbrcRefreshStoneId(stockNum, stockNumKey) {
    const response = await get_stone_info(stockNum, stockNumKey);
    if (!response || response.success !== true || !response.data) return null;

    const stone = response.data;
    const nextStockNum = String(stone.stock_num || stockNum).trim();
    const nextStockId = vdbrcNormalizeStockId(stone.id);
    if (!nextStockNum || !nextStockId) return null;

    vdbrcSetStoneButtonData({
        'data-stone-stock-num': nextStockNum,
        'data-stone-stock-id': nextStockId
    });

    return { stockNum: nextStockNum, stockId: nextStockId };
}

async function vdbrcAddProductInfo(stockNumKey, stockNum, stockId, price, image, title, vendorId) {
    const sendData = new URLSearchParams();
    sendData.append("action", "add_product_info");
    sendData.append("shop", shop);
    sendData.append(stockNumKey, stockNum);
    sendData.append("stock_id", stockId);
    if (vendorId) sendData.append("vendor_id", vendorId);
    if (price !== '' && price != null && price !== 'NaN') sendData.append("product_price", price);
    const apiImage = vdbrcStoneImageForApi(image);
    if (apiImage) sendData.append("prod_img", apiImage);
    if (title) sendData.append("product_title", title);
    return vdbrcPostApi(sendData.toString());
}

async function addStoneToCart($btn, reviewUrl) {
    const params = vdbrcCurrentParams();
    const stockNumKey = params.get('natural_stock_num') ? 'natural_stock_num' : 'labgrown_stock_num';
    let stockNum = String($btn.attr('data-stone-stock-num') || '').trim();
    let stockId = vdbrcNormalizeStockId($btn.attr('data-stone-stock-id'));
    const price = $btn.attr('data-stone-price') || '';
    const image = $btn.attr('data-stone-image') || '';
    const title = $btn.attr('data-stone-title') || '';
    const vendorId = String($btn.attr('data-vendor-id') || vdbrcVendorIdFromUrl() || '').trim();

    if (!stockNum) {
        throw new Error('The selected stone is missing. Please choose a stone and try again.');
    }

    if (!stockId) {
        const refreshed = await vdbrcRefreshStoneId(stockNum, stockNumKey);
        if (!refreshed) {
            throw new Error('The selected stone is missing. Please choose a stone and try again.');
        }
        stockNum = refreshed.stockNum;
        stockId = refreshed.stockId;
    }

    let responseData = await vdbrcAddProductInfo(stockNumKey, stockNum, stockId, price, image, title, vendorId);

    if (!vdbrcProductInfoReady(responseData)) {
        const refreshed = await vdbrcRefreshStoneId(stockNum, stockNumKey);
        if (refreshed) {
            stockNum = refreshed.stockNum;
            stockId = refreshed.stockId;
        }
        responseData = await vdbrcAddProductInfo(stockNumKey, stockNum, stockId, price, '', title, vendorId);
    }

    if (!vdbrcProductInfoReady(responseData)) {
        throw new Error('The diamond could not be added to the cart. Please try again.');
    }

    await vdbrcUpsertCartLine(responseData.data.var_id, vdbrcStoneLineProperties($btn, reviewUrl));
}

async function shopifyAddToCart(variantId, qty = 1, properties = null) {
    const payload = {
        id: Number(variantId),
        quantity: qty
    };

    // Optional: line item properties (shows under item in cart)
    if (properties && typeof properties === "object") {
        payload.properties = properties;
    }

    const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(payload)
    });

    // Shopify returns 200 + JSON on success, 4xx + JSON on error
    const data = await res.json().catch(() => null);

    if (!res.ok) {
        const msg = (data && (data.description || data.message)) || 'Shopify cart add failed';
        throw new Error(msg);
    }

    return data; // contains added line item object
}

async function vdbrcChangeCartLine(lineKey, quantity, properties) {
    const payload = { id: lineKey, quantity: quantity };
    if (properties) payload.properties = properties;

    const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(payload)
    });
    const data = await res.json().catch(() => null);
    if (!res.ok) {
        const msg = (data && (data.description || data.message)) || 'Could not update the cart.';
        throw new Error(msg);
    }
    return data;
}

async function vdbrcUpsertCartLine(variantId, properties) {
    const variant = Number(variantId);
    if (!variant) {
        throw new Error('The selected product is still loading. Please try again.');
    }

    const pairId = properties && properties['_Pair ID'];
    const role = properties && properties['_Line Role'];
    const cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
    const cart = await cartRes.json().catch(() => null);
    if (!cartRes.ok || !cart) {
        throw new Error('Could not read the cart.');
    }

    const existing = (cart.items || []).find(function (item) {
        const props = item.properties || {};
        return pairId && role && props['_Pair ID'] === pairId && props['_Line Role'] === role;
    });

    if (!existing) {
        return shopifyAddToCart(variant, 1, properties);
    }

    if (Number(existing.variant_id) !== variant) {
        await vdbrcChangeCartLine(existing.key, 0);
        return shopifyAddToCart(variant, 1, properties);
    }

    return vdbrcChangeCartLine(existing.key, 1, properties);
}

$('body').on('click', '.vdbrc_drop_a_hint_btn', async function (e) {
    e.preventDefault();

    function validateDropAHint(data) {
        if (!data.recipient_name) {
            return { isValid: false, message: "Recipient name is required." };
        }

        if (!data.recipient_email) {
            return { isValid: false, message: "Recipient email is required." };
        }

        if (!isValidEmail(data.recipient_email)) {
            return { isValid: false, message: "Please enter a valid recipient email address." };
        }

        if (!data.your_name) {
            return { isValid: false, message: "Your name is required." };
        }

        if (!data.your_email) {
            return { isValid: false, message: "Your email is required." };
        }

        if (!isValidEmail(data.your_email)) {
            return { isValid: false, message: "Please enter a valid your email address." };
        }

        if (data.your_phone && !isValidPhone(data.your_phone)) {
            return { isValid: false, message: "Please enter a valid phone number." };
        }

        if (data.share_message && data.share_message.length > 500) {
            return { isValid: false, message: "Message cannot exceed 500 characters." };
        }

        if (!data.url) {
            return { isValid: false, message: "Invalid product URL." };
        }

        return { isValid: true };
    }

    function isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    function isValidPhone(phone) {
        const phoneRegex = /^[0-9+\-\s()]{7,15}$/;
        return phoneRegex.test(phone);
    }
    const dropAHintData = {
        your_name: $('.dropahint_your_name').val().trim(),
        your_email: $('.dropahint_your_email').val().trim(),
        your_phone: $('.dropahint_your_phone').val().trim(),
        recipient_name: $('.dropahint_recipient_name').val().trim(),
        recipient_email: $('.dropahint_recipient_email').val().trim(),
        share_message: $('.dropahint_message').val().trim(),
        url: window.location.href
    };

    const validation = validateDropAHint(dropAHintData);
    if (!validation.isValid) {
        alert(validation.message);
        return;
    }

    const $btn = $(this);
    $btn.prop('disabled', true);

    const response = await drop_hint(dropAHintData);
    $btn.prop('disabled', false);

    if (response && response.status === 'success') {
        alert('Your hint has been sent successfully!');

        $('.dropahint_your_name, .dropahint_your_email, .dropahint_your_phone, ' +
            '.dropahint_recipient_name, .dropahint_recipient_email, .dropahint_message'
        ).val('');

        // $('#dropAHintModal').modal('hide');
    } else {
        alert(response?.message || 'Failed to send your hint. Please try again later.');
    }
});

async function drop_hint(dropAHintData) {
    if (!productHandle) {
        console.error("Product handle is required");
        return null;
    }

    const sendData = new URLSearchParams();
    sendData.append("action", "drop_hint");
    sendData.append("shop", shop);
    sendData.append("your_name", dropAHintData.your_name);
    sendData.append("your_email", dropAHintData.your_email);
    sendData.append("your_phone", dropAHintData.your_phone);
    sendData.append("recipient_name", dropAHintData.recipient_name);
    sendData.append("recipient_email", dropAHintData.recipient_email);
    sendData.append("share_message", dropAHintData.share_message);
    sendData.append("url", dropAHintData.url);

    try {
        const responseData = await new Promise((resolve, reject) => {
            $.post(API_URL, sendData.toString(), (resultData) => {
                try {
                    const parsed = JSON.parse(resultData);
                    resolve(parsed);
                } catch (e) {
                    reject("Invalid JSON response: " + e);
                }
            }).fail((error) => reject(error));
        });

        return responseData;

    } catch (error) {
        console.error("Error loading stones:", error);
        return null;
    }
}

//#region : General Functions
function formatValue(value, defaultValue = "") {
    return value ?? defaultValue;
}
function formatSize(size) {
    return size ? Number(size).toFixed(2) : "";
}
function vdbrcMoneyWithCurrency(formattedAmount) {
    if (currency_code_enabled && market_currency) {
        return formattedAmount + ' ' + market_currency;
    }
    return formattedAmount;
}

function vdbrcApplySettingPrice(productData) {
    const rawPrice = productData ? productData.price : 0;
    const formattedPrice = handlePriceData(shop_currency, rawPrice, false);
    const priceWithoutFormat = handlePriceData(shop_currency, rawPrice, true);

    $('.srevi-price-current.vdbrc_setting_prod_price').text(formattedPrice);

    const $row = $('#vdbrc_setting_price_row');
    const saleAmount = parseFloat(rawPrice);
    const compareAmount = parseFloat(productData ? productData.compare_at_price : '');
    const showCompare = Number.isFinite(saleAmount) && Number.isFinite(compareAmount) && compareAmount > saleAmount;

    $row.find('.vdbrc_setting_prod_price').text(vdbrcMoneyWithCurrency(formattedPrice));

    const $compare = $row.find('.vdbrc_setting_compare_price');
    const $badge = $row.find('.vdbrc_setting_save_badge');

    if (showCompare) {
        const formattedCompare = handlePriceData(shop_currency, compareAmount, false);
        const formattedSave = handlePriceData(shop_currency, compareAmount - saleAmount, false);
        const saveLabel = (typeof vdbrcSaveLabel === 'string' ? vdbrcSaveLabel : 'Save __AMOUNT__').replace('__AMOUNT__', formattedSave);
        $compare.text(vdbrcMoneyWithCurrency(formattedCompare)).removeAttr('hidden');
        $badge.text(saveLabel).removeAttr('hidden');
        $row.addClass('is-on-sale');
    } else {
        $compare.text('').attr('hidden', 'hidden');
        $badge.text('').attr('hidden', 'hidden');
        $row.removeClass('is-on-sale');
    }

    return priceWithoutFormat;
}

function handlePriceData(stoneCurrencyCode, total_sales_price, withoutFormate = false) {
    // Helper function to check if a value is defined and not empty
    function isValidCurrency(currency) {
        return currency !== undefined && currency !== null && currency !== "";
    }
    // Initial price conversion to shop currency
    let price = Math.round(price_in_shop_currency(total_sales_price));
    if (isValidCurrency(stoneCurrencyCode) && stoneCurrencyCode !== "USD") {
        if (stoneCurrencyCode !== shop_currency) {
            // Convert to USD first, then to shop currency
            let usd_price = parseFloat(currency_conversion(total_sales_price, stoneCurrencyCode, "USD"));
            price = Math.round(price_in_shop_currency(usd_price));
        } else {
            price = Math.round(total_sales_price);
        }
    }
    if (withoutFormate) {
        price = Math.round(total_sales_price);
    } else {
        price = vdbrcFormatMoney(price * 100, moneyFormat);
    }
    // Convert price to market currency if different from shop currency
    if (market_currency !== shop_currency) {
        price = Math.round(price_in_market_currency(total_sales_price));
        if (isValidCurrency(stoneCurrencyCode) && stoneCurrencyCode !== "USD") {
            if (stoneCurrencyCode !== market_currency) {
                // Convert to USD first, then to market currency
                let usd_price = parseFloat(currency_conversion(total_sales_price, stoneCurrencyCode, "USD"));
                price = Math.round(price_in_market_currency(usd_price));
            } else {
                price = Math.round(total_sales_price);
            }
        }
        if (withoutFormate) {
            price = Math.round(total_sales_price);
        } else {
            price = vdbrcFormatMoney(price * 100, market_currency_symbol + " {amount}");
        }
    }
    return price;
}
function debounce(func, wait) {
    let timeout;
    return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
    };
}
function isMobileDevice() {
    return /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent);
}
function updateUrl(url, key, value) {
    if (value !== undefined) {
        value = encodeURI(value);
    }
    var hashIndex = url.indexOf("#") | 0;
    if (hashIndex === -1) hashIndex = url.length | 0;
    var urls = url.substring(0, hashIndex).split("?");
    var baseUrl = urls[0];
    var parameters = "";
    var outPara = {};
    if (urls.length > 1) {
        parameters = urls[1];
    }
    if (parameters !== "") {
        parameters = parameters.split("&");
        for (k in parameters) {
            var keyVal = parameters[k];
            keyVal = keyVal.split("=");
            var ekey = keyVal[0];
            var evalue = "";
            if (keyVal.length > 1) {
                evalue = keyVal[1];
            }
            outPara[ekey] = evalue;
        }
    }
    if (value !== undefined) {
        outPara[key] = value;
    } else {
        delete outPara[key];
    }
    parameters = [];
    for (var k in outPara) {
        parameters.push(k + "=" + outPara[k]);
    }
    var finalUrl = baseUrl;
    if (parameters.length > 0) {
        finalUrl += "?" + parameters.join("&");
    }
    return finalUrl + url.substring(hashIndex);
}
function resetDeepLink(keepParams = []) {
    const url = new URL(window.top.location.href);
    const searchParams = new URLSearchParams(url.search);

    // Remove everything except allowed params
    for (const key of Array.from(searchParams.keys())) {
        if (!keepParams.includes(key)) {
            searchParams.delete(key);
        }
    }

    const newQuery = searchParams.toString();
    const newUrl = url.pathname + (newQuery ? `?${newQuery}` : '') + url.hash;

    window.top.history.pushState({}, '', newUrl);
}
function removeURLParameters(url, ...parameters) {
    const parsed = new URL(url);
    parameters.forEach(e => parsed.searchParams.delete(e))
    return parsed.toString()
}
//#endregion

//#region : Ring Size Dropdown Logic
$('body').on('click', '.spdp-ring-size-selected', function (e) {
    e.stopPropagation();
    const $dropdown = $(this).closest('.spdp-ring-size-dropdown');
    $('.spdp-ring-size-dropdown').not($dropdown).removeClass('active');
    $dropdown.toggleClass('active');
});
$('body').on('click', '.spdp-ring-size-option', function () {
    var option = $(this);
    var dropdown = option.closest('.spdp-ring-size-dropdown');
    var value = option.data('value');
    var text = option.text();
    var placeholder = dropdown.find('.spdp-ring-size-placeholder');

    $(".vdbrc_ring_size_input").val(value).trigger('change');
    document.cookie = `vdbrc_setting_ring_size=${value}`;

    placeholder.text(text).css('color', '#000000');

    dropdown.find('.spdp-ring-size-option').removeClass('selected');
    option.addClass('selected');

    dropdown.removeClass('active');
});
$('body').on('click', function (e) {
    if (!$(e.target).closest('.spdp-ring-size-dropdown').length) {
        $('.spdp-ring-size-dropdown').removeClass('active');
    }
});
//#endregion

$('body').on('click', '.vdbrc_setting_prod_read_more', function (e) {
    e.preventDefault();

    const $target = $('.stonepdp-accordions-wrapper .stonepdp-accordion-header.data-description');

    if ($target.length) {
        $target.click();
        $('html, body').animate({
            scrollTop: $target.offset().top - 100
        }, 500);
    }
});
//#region : ThreeD Functions
async function handleThreeDPart(head_glb, shank_glb, isUpdate = false) {
    if (!(head_glb && shank_glb)) return false;
    {
        const headUrl = head_glb;
        const shankUrl = shank_glb;

        function readValue(type) {
            var text = $(`.vdbrc_setting_pdp_option[data-type="${type}"] .vdbrc_selected_option_value`).text() || '';
            return $.trim(text.replace(':', ''));
        }

        let selectedMetalColorVal = readValue("Color");
        selectedMetalColorVal = selectedMetalColorVal.toLowerCase();

        let selectedMetalVal = readValue("Metal");
        selectedMetalVal = selectedMetalVal.toLowerCase();

        let selectedShapeVal = readValue("Shape");
        selectedShapeVal = selectedShapeVal.toLowerCase();

        let metalHeadColor = 'white_gold';
        let metalShankColor = 'white_gold';
        if(selectedMetalVal.includes('platinum')){
            metalHeadColor = 'white_gold';
            metalShankColor = 'white_gold';
        }else if (selectedMetalColorVal.includes('two tone yellow')) {
            metalHeadColor = 'white_gold';
            metalShankColor = 'yellow_gold';
        } else if (selectedMetalColorVal.includes('two tone rose')) {
            metalHeadColor = 'white_gold';
            metalShankColor = 'rose_gold';
        } else if (selectedMetalColorVal.includes('rose')) {
            metalHeadColor = 'rose_gold';
            metalShankColor = 'rose_gold';
        } else if (selectedMetalColorVal.includes('yellow')) {
            metalHeadColor = 'yellow_gold';
            metalShankColor = 'yellow_gold';
        } else if (selectedMetalColorVal.includes('W+Y Gold')) {
            metalHeadColor = 'white_gold';
            metalShankColor = 'yellow_gold';
        } else if (selectedMetalColorVal.includes('W+R Gold')) {
            metalHeadColor = 'white_gold';
            metalShankColor = 'rose_gold';
        } else if (selectedMetalColorVal.includes('White/Yellow Gold')) {
            metalHeadColor = 'white_gold';
            metalShankColor = 'yellow_gold';
        } else if (selectedMetalColorVal.includes('White/Yellow Gold')) {
            metalHeadColor = 'white_gold';
            metalShankColor = 'yellow_gold';
        } else if (selectedMetalColorVal.includes('White/Rose Gold')) {
            metalHeadColor = 'white_gold';
            metalShankColor = 'rose_gold';
        }

        const metalHead = three_d_static_data[0]['pmat'][metalHeadColor];
        const metalShank = three_d_static_data[0]['pmat'][metalShankColor];

        let dmatFile = three_d_static_data[0]['dmat'][selectedShapeVal];
        if(!dmatFile){
            dmatFile = three_d_static_data[0]['dmat']['default'];
        }

        let three_d_media_arr = generateThreeDMediaArray(headUrl, shankUrl, metalHead, metalShank, dmatFile);

        console.log('3D Media Array',three_d_media_arr);

        if (three_d_media_arr.length > 0) {
            if (!window.player) return false;

            if (vdbrcThreeDInitialized && typeof window.player.update === 'function') {
                return await window.player.update(canvasId, three_d_media_arr) !== false;
            } else if (typeof window.player.init === 'function') {
                vdbrcThreeDInitialized = true;
                const loaded = await window.player.init(canvasId, three_d_media_arr);
                if (loaded === false) vdbrcThreeDInitialized = false;
                return loaded !== false;
            }
        }
        return false;
    }
}
function generateThreeDMediaArray(head, shank, metal_head, metal_shank, dmat) {
    let three_d_media = [
        {
            "option_type": "model",
            "option_value": head,
            "option_identifier": "head"
        },
        {
            "option_type": "model",
            "option_value": shank,
            "option_identifier": "shank"
        },
        {
            "option_type": "material",
            "option_value": metal_head,
            "option_identifier": "metal-top,metal- top,Metal 02,Metal 04,head,EW,metal-head"
        },
        {
            "option_type": "material",
            "option_value": metal_shank,
            "option_identifier": "metal-shank,metal-shape,shank"
        },
        {
            "option_type": "material",
            "option_value": dmat,
            "option_identifier": "Gem 01, Gem 02, egt, maine stone-long cushion, mainestoe-princess, mainestone-emerald, mainestone-long cushin, mainestone-long cushion, mainestone-marquise, mainestone-oval, mainestone-princess, mainestone-radiant, mainestone-round, mainstone- marquise, mainstone-Marquise, mainstone-RADIANT, mainstone-asscher, mainstone-cushion, mainstone-emerald, mainstone-heart, mainstone-long cushion, mainstone-marquise, mainstone-oval, mainstone-ovel, mainstone-pear, mainstone-princess, mainstone-radian, mainstone-radiant, mainstone-round, mainstone-sq cushion, mainstone-sq-cushion, mainstone-square cushion, mainstone-square-cushion, shanklsidestone-round, shanksidestone-baguette, shanksidestone-marquise, shanksidestone-round, sidestone-baguette, sidestone-emerald, sidestone-marquise, sidestone-pear, sidestone-round, sidestone-round.001"
        }
    ];

    return three_d_media;
}
//#endregion

function initSimpleSlider(sliderSelector) {

    var slider = $(sliderSelector);
    if (!slider.length) return;

    var track = slider.find(".slider-track");
    var slides = slider.find(".slide");
    var prev = slider.find(".prev");
    var next = slider.find(".next");
    var dotsWrap = slider.find(".slider-dots");

    var index = 0;
    var total = slides.length;

    if (!total) return;

    dotsWrap.empty(); // reset dots (important for dynamic slides)

    // Create dots
    slides.each(function (i) {
        var dot = $("<button></button>");
        if (i === 0) dot.addClass("active");

        dot.on("click", function () {
            index = i;
            updateSlider();
        });

        dotsWrap.append(dot);
    });

    var dots = dotsWrap.find("button");

    function updateSlider() {
        track.css("transform", "translateX(-" + (index * 100) + "%)");

        dots.removeClass("active");
        dots.eq(index).addClass("active");
    }

    next.off("click").on("click", function () {
        index++;
        if (index >= total) index = 0;
        updateSlider();
    });

    prev.off("click").on("click", function () {
        index--;
        if (index < 0) index = total - 1;
        updateSlider();
    });

}